<template>
    <div class="flex items-center justify-center">
        <!-- AIRPLANE ICON -->
        <svg
            v-if="icon === 'airplane'"
            :class="svgClass"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.02427 3.3213C5.95467 3.31016 5.91205 3.31602 5.88561 3.32323L5.87254 3.3268L5.43637 3.43065C5.37228 3.44908 5.35106 3.46821 5.34728 3.47171C5.34415 3.4746 5.32892 3.48863 5.31268 3.53835C5.29457 3.59383 5.29812 3.61921 5.29959 3.62756C5.30121 3.63677 5.308 3.66739 5.35004 3.72256L5.35461 3.72856L8.75041 8.27024C8.91628 8.49208 8.96108 8.78182 8.86997 9.04339C8.77885 9.30496 8.56373 9.50416 8.29594 9.57494L5.37927 10.3458C5.11835 10.4147 4.84019 10.3531 4.63286 10.1803L2.63614 8.51635C2.61874 8.51599 2.5991 8.51719 2.57659 8.52075L2.12255 8.63919L2.12388 8.64125L4.02537 11.8174C4.12863 11.9861 4.25783 12.0945 4.42918 12.1644C4.5975 12.2331 4.7613 12.2445 4.9497 12.1938L16.6111 9.04933C16.8467 8.98225 17.0036 8.85872 17.1222 8.65382C17.2375 8.45471 17.2622 8.26676 17.1975 8.03655C17.1306 7.7989 17.0069 7.64096 16.8009 7.5217C16.6018 7.40643 16.4138 7.38173 16.1836 7.44647L16.1757 7.44871L13.055 8.2931C12.5276 8.43579 11.9638 8.31097 11.5459 7.95902L6.05851 3.33698L6.05021 3.32961C6.04842 3.32801 6.04736 3.32732 6.04736 3.32732C6.04736 3.32732 6.03998 3.32381 6.02427 3.3213ZM5.46207 1.71127C5.73635 1.6389 6.01494 1.63194 6.28759 1.67556C6.60545 1.72642 6.89984 1.85829 7.14779 2.07538L12.6196 6.68429L15.7367 5.84084C16.3939 5.65715 17.0447 5.73702 17.636 6.07933C18.2216 6.41841 18.6187 6.93408 18.8019 7.58531C18.9871 8.24399 18.9077 8.89632 18.5646 9.48888C18.2255 10.0746 17.7099 10.4716 17.0586 10.6548L17.05 10.6572L5.3833 13.803C4.84948 13.9467 4.31158 13.9165 3.79935 13.7075C3.2909 13.4999 2.88576 13.1506 2.60035 12.6817L2.59717 12.6765L0.707705 9.52043C0.415264 9.05939 0.36842 8.53216 0.568301 8.02579C0.771687 7.51055 1.17604 7.15934 1.70949 7.0245L2.20847 6.89434L2.23208 6.88961C2.46177 6.84368 2.69665 6.83609 2.93173 6.87321C3.23094 6.92046 3.49142 7.05315 3.70629 7.23863L5.36934 8.6245L6.67604 8.27916L4.02176 4.72927C3.64045 4.22678 3.53022 3.62777 3.72834 3.02101C3.93139 2.39917 4.39397 1.9852 5.0122 1.81875L5.02397 1.81558L5.46207 1.71127Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.04144 16.8734C1.04144 16.4132 1.41453 16.0401 1.87477 16.0401H13.1248C13.585 16.0401 13.9581 16.4132 13.9581 16.8734C13.9581 17.3337 13.585 17.7068 13.1248 17.7068H1.87477C1.41453 17.7068 1.04144 17.3337 1.04144 16.8734Z"
                fill="currentColor"
            />
        </svg>
        <!-- ACCESSIBLE OR WHEELCHAIR ICON -->
        <svg
            v-if="icon === 'accessible' || icon === 'wheelchair'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="Vector"
                d="M8.75 6.75V12.75H17L20 18.75L22.25 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="Vector_2"
                d="M8.75 6.75C9.99264 6.75 11 5.74264 11 4.5C11 3.25736 9.99264 2.25 8.75 2.25C7.50736 2.25 6.5 3.25736 6.5 4.5C6.5 5.74264 7.50736 6.75 8.75 6.75Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="Vector_3"
                d="M14.75 9H9.5C7.9087 9 6.38258 9.63214 5.25736 10.7574C4.13214 11.8826 3.5 13.4087 3.5 15C3.5 16.5913 4.13214 18.1174 5.25736 19.2426C6.38258 20.3679 7.9087 21 9.5 21C12.2956 21 14.8344 19.0875 15.5 16.5"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <!-- AIR CONDITIONING ICON -->
        <svg
            v-if="icon === 'air_conditioning'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                id="vector"
                d="M12.043 5.5V18.5M12.043 5.5L9.54297 3M12.043 5.5L14.543 3M12.043 18.5L9.54297 21M12.043 18.5L14.543 21M6.41506 8.74998L17.6734 15.25M6.41506 8.74998L3 9.66504M6.41506 8.74998L5.5 5.33491M17.6734 15.25L18.5885 18.665M17.6734 15.25L21.0885 14.3349M6.41506 15.25L17.6734 8.74998M6.41506 15.25L5.5 18.665M6.41506 15.25L3 14.3349M17.6734 8.74998L21.0885 9.66504M17.6734 8.74998L18.5885 5.33491"
                stroke="black"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                :class="svgClass"
            />
        </svg>
        <!-- BAG LOCKER ICON -->
        <svg
            v-if="icon === 'bag_locker'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10 4C9.44772 4 9 4.44772 9 5V6H15V5C15 4.44772 14.5523 4 14 4H10ZM17 6V5C17 3.34315 15.6569 2 14 2H10C8.34315 2 7 3.34315 7 5V6H5C3.34315 6 2 7.34315 2 9V18C2 19.6569 3.34315 21 5 21H19C20.6569 21 22 19.6569 22 18V9C22 7.34315 20.6569 6 19 6H17ZM5 8C4.44772 8 4 8.44772 4 9V18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18V9C20 8.44772 19.5523 8 19 8H5Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                d="M15.5 17C16.7402 17 17.7695 16.0969 17.9661 14.9125C18.0096 14.6509 17.8946 14.3947 17.7071 14.2071L15.7929 12.2929C15.6054 12.1054 15.3491 11.9904 15.0875 12.0339C13.9031 12.2305 13 13.2598 13 14.5C13 15.8807 14.1193 17 15.5 17Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                d="M6.20548 12.8031C6.01658 12.2841 6.28417 11.7102 6.80315 11.5214L9.78863 10.4347C10.3076 10.2458 10.8815 10.5134 11.0703 11.0324L11.4531 12.0841C11.642 12.6031 11.3744 13.1769 10.8555 13.3658L7.86998 14.4524C7.351 14.6413 6.77715 14.3737 6.58826 13.8548L6.20548 12.8031Z"
                fill="currentColor"
            />
        </svg>

        <!-- BATHROOM ICON -->
        <svg
            v-if="icon === 'bathroom'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.75 8C13.8615 8 13.0632 8.38625 12.5139 9H6.5H6.25V4.87501C6.25 4.64294 6.34219 4.42038 6.50628 4.25629C6.67038 4.09219 6.89294 4.00001 7.125 4.00001L7.12735 4C7.33614 3.99951 7.53884 4.07035 7.70188 4.20078C7.86492 4.33121 7.97852 4.51342 8.02388 4.71722C8.14384 5.25632 8.67812 5.59609 9.21722 5.47613C9.75632 5.35616 10.0961 4.82189 9.97612 4.28279C9.83177 3.63411 9.4702 3.05418 8.95127 2.63904C8.62694 2.37958 8.25331 2.19421 7.85645 2.09205C7.61908 2.03095 7.3734 1.99962 7.125 2.00001C6.3625 2.00001 5.63124 2.30291 5.09207 2.84207C4.5529 3.38124 4.25 4.11251 4.25 4.87501V9H3.5C1.84315 9 0.5 10.3431 0.5 12V13.5C0.5 14.9587 1.07946 16.3576 2.11091 17.3891C3.08329 18.3615 4.38226 18.9321 5.75 18.9943V20.25C5.75 20.8023 6.19772 21.25 6.75 21.25C7.30228 21.25 7.75 20.8023 7.75 20.25V19H16.25V20.25C16.25 20.8023 16.6977 21.25 17.25 21.25C17.8023 21.25 18.25 20.8023 18.25 20.25V18.9943C19.6177 18.9321 20.9167 18.3615 21.8891 17.3891C22.9205 16.3576 23.5 14.9587 23.5 13.5V12C23.5 10.3431 22.1569 9 20.5 9H18.9861C18.4368 8.38625 17.6385 8 16.75 8H14.75ZM11.75 11H3.5C2.94772 11 2.5 11.4477 2.5 12V13.5C2.5 14.4283 2.86875 15.3185 3.52513 15.9749C4.1815 16.6313 5.07174 17 6 17H18C18.9283 17 19.8185 16.6313 20.4749 15.9749C21.1313 15.3185 21.5 14.4283 21.5 13.5V12C21.5 11.4477 21.0523 11 20.5 11H19.75V11.5C19.75 13.1569 18.4069 14.5 16.75 14.5H14.75C13.0931 14.5 11.75 13.1569 11.75 11.5V11ZM14.75 10C14.1977 10 13.75 10.4477 13.75 11V11.5C13.75 12.0523 14.1977 12.5 14.75 12.5H16.75C17.3023 12.5 17.75 12.0523 17.75 11.5V11C17.75 10.4477 17.3023 10 16.75 10H14.75Z"
                fill="currentColor"
            />
        </svg>
        <!-- BAR ICON  -->
        <svg
            v-if="icon === 'drink'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.5 3C15.2239 3 15 3.22386 15 3.5V5.75736C15 6.47951 14.8047 7.18151 14.4435 7.79271C14.274 8.07948 14.0679 8.34629 13.8284 8.58579C13.4379 8.97631 12.8048 8.97631 12.4142 8.58579C12.0237 8.19526 12.0237 7.5621 12.4142 7.17157C12.534 7.05177 12.637 6.91841 12.7217 6.77507C12.9024 6.46937 13 6.11838 13 5.75736V3.5C13 2.11929 14.1193 1 15.5 1H16.5C17.8807 1 19 2.11929 19 3.5V5.75736C19 6.28779 19.2107 6.7965 19.5858 7.17157L20.8284 8.41421C21.5786 9.16436 22 10.1818 22 11.2426V19C22 21.2091 20.2092 23 18 23H14C13.4477 23 13 22.5523 13 22C13 21.4477 13.4477 21 14 21H18C19.1046 21 20 20.1046 20 19V11.2426C20 10.7122 19.7893 10.2035 19.4142 9.82843L18.1716 8.58579C17.4214 7.83564 17 6.81823 17 5.75736V3.5C17 3.22386 16.7762 3 16.5 3H15.5Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.3047 11.75C4.12346 12.1504 4.02032 12.5834 4.00271 13.0258L4.00155 13.0591C3.98336 13.6637 4.1257 14.2626 4.41436 14.7947C4.70831 15.3365 5.14308 15.789 5.67278 16.1042C6.20249 16.4195 6.80749 16.5859 7.42391 16.5859C8.04034 16.5859 8.64534 16.4195 9.17504 16.1042C9.70475 15.789 10.1395 15.3365 10.4335 14.7947C10.7221 14.2626 10.8645 13.6637 10.8463 13.0591L10.8451 13.0258C10.8275 12.5834 10.7244 12.1504 10.5431 11.75H4.3047ZM2.52853 10.8266C2.88186 10.0859 3.62678 9.75 4.29719 9.75H10.5506C11.2211 9.75 11.966 10.0859 12.3193 10.8266C12.6349 11.4881 12.8142 12.209 12.8435 12.9462L12.8454 12.9989C12.8742 13.9568 12.6487 14.9055 12.1914 15.7484C11.7258 16.6067 11.037 17.3234 10.1979 17.8229C9.64828 18.15 9.04747 18.3759 8.42391 18.4929V21H9.56884C10.1211 21 10.5688 21.4477 10.5688 22C10.5688 22.5523 10.1211 23 9.56884 23H5.27899C4.7267 23 4.27899 22.5523 4.27899 22C4.27899 21.4477 4.7267 21 5.27899 21H6.42391V18.4929C5.80036 18.3759 5.19954 18.15 4.6499 17.8229C3.81078 17.3234 3.12205 16.6067 2.6564 15.7484C2.19913 14.9055 1.97364 13.9568 2.00245 12.9989L2.00429 12.9462C2.03364 12.209 2.21296 11.4881 2.52853 10.8266Z"
                fill="currentColor"
            />
        </svg>
        <!-- BUSINESS CENTER ICON -->
        <svg
            v-if="icon === 'business_center'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 4C11.1716 4 10.5 4.67157 10.5 5.5C10.5 6.32843 11.1716 7 12 7C12.8284 7 13.5 6.32843 13.5 5.5C13.5 4.67157 12.8284 4 12 4ZM8.5 5.5C8.5 3.567 10.067 2 12 2C13.933 2 15.5 3.567 15.5 5.5C15.5 7.433 13.933 9 12 9C10.067 9 8.5 7.433 8.5 5.5ZM4 8.5C4.55228 8.5 5 8.94772 5 9.5V11H5.5V9.5C5.5 8.94772 5.94772 8.5 6.5 8.5C7.05228 8.5 7.5 8.94772 7.5 9.5V11H8.3302C9.23148 10.0637 10.516 9.5 12 9.5C13.484 9.5 14.7685 10.0637 15.6698 11H21C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V13C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11V9.5C3 8.94772 3.44772 8.5 4 8.5ZM5 13V18C5 18.5523 5.44772 19 6 19H18C18.5523 19 19 18.5523 19 18V13H5Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
        <!-- CLOCK ICON -->
        <svg
            v-if="icon === 'clock'"
            :class="svgClass"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0013 3.33268C6.3194 3.33268 3.33464 6.31745 3.33464 9.99935C3.33464 13.6812 6.3194 16.666 10.0013 16.666C13.6832 16.666 16.668 13.6812 16.668 9.99935C16.668 6.31745 13.6832 3.33268 10.0013 3.33268ZM1.66797 9.99935C1.66797 5.39698 5.39893 1.66602 10.0013 1.66602C14.6037 1.66602 18.3346 5.39698 18.3346 9.99935C18.3346 14.6017 14.6037 18.3327 10.0013 18.3327C5.39893 18.3327 1.66797 14.6017 1.66797 9.99935ZM10.0013 5.83268C10.4615 5.83268 10.8346 6.20578 10.8346 6.66602V9.65417L12.6739 11.4934C12.9993 11.8189 12.9993 12.3465 12.6739 12.6719C12.3485 12.9974 11.8208 12.9974 11.4954 12.6719L9.41205 10.5886C9.25577 10.4323 9.16797 10.2204 9.16797 9.99935V6.66602C9.16797 6.20578 9.54106 5.83268 10.0013 5.83268Z"
                fill="currentColor"
            />
        </svg>

        <!-- SHOE SHINE ICON -->
        <svg
            v-if="icon === 'shoe-shine'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.26815 6.14843C4.65489 8.05063 4.54297 10.182 5.16669 11.5267C5.18765 11.5718 5.22709 11.6207 5.3136 11.6657C5.40659 11.7142 5.5424 11.75 5.70445 11.75H8.54602C8.70807 11.75 8.84388 11.7142 8.93688 11.6657C9.02339 11.6207 9.06283 11.5718 9.08378 11.5267C9.7075 10.182 9.59559 8.05063 8.98233 6.14843C8.68281 5.2194 8.28945 4.43063 7.88594 3.89682C7.44311 3.311 7.16223 3.25 7.12524 3.25C7.08825 3.25 6.80736 3.311 6.36454 3.89682C5.96102 4.43063 5.56766 5.2194 5.26815 6.14843ZM4.76908 2.69079C5.30475 1.98214 6.10504 1.25 7.12524 1.25C8.14543 1.25 8.94572 1.98214 9.4814 2.69079C10.0564 3.45144 10.5389 4.45846 10.8858 5.53475C11.5656 7.64318 11.8294 10.3605 10.8981 12.3682C10.4274 13.383 9.38609 13.75 8.54602 13.75H5.70445C4.86438 13.75 3.82308 13.383 3.35236 12.3682C2.42112 10.3605 2.68488 7.64318 3.36462 5.53475C3.71161 4.45846 4.19409 3.45144 4.76908 2.69079ZM15.0181 8.39843C14.4049 10.3006 14.293 12.432 14.9167 13.7767C14.9376 13.8218 14.9771 13.8707 15.0636 13.9157C15.1566 13.9642 15.2924 14 15.4545 14H18.296C18.4581 14 18.5939 13.9642 18.6869 13.9157C18.7734 13.8707 18.8128 13.8218 18.8338 13.7767C19.4575 12.432 19.3456 10.3006 18.7323 8.39843C18.4328 7.4694 18.0395 6.68063 17.6359 6.14682C17.1931 5.561 16.9122 5.5 16.8752 5.5C16.8382 5.5 16.5574 5.561 16.1145 6.14682C15.711 6.68063 15.3177 7.4694 15.0181 8.39843ZM14.5191 4.94079C15.0548 4.23214 15.855 3.5 16.8752 3.5C17.8954 3.5 18.6957 4.23214 19.2314 4.94079C19.8064 5.70144 20.2889 6.70846 20.6359 7.78475C21.3156 9.89318 21.5794 12.6105 20.6481 14.6182C20.1774 15.633 19.1361 16 18.296 16H15.4545C14.6144 16 13.5731 15.633 13.1024 14.6182C12.1711 12.6105 12.4349 9.89318 13.1146 7.78475C13.4616 6.70846 13.9441 5.70144 14.5191 4.94079ZM3.50024 16.875C3.50024 15.7014 4.45163 14.75 5.62524 14.75H8.62524C9.79884 14.75 10.7502 15.7014 10.7502 16.875C10.7502 17.8364 10.3683 18.7584 9.6885 19.4383C9.00868 20.1181 8.08665 20.5 7.12524 20.5C6.16383 20.5 5.24179 20.1181 4.56198 19.4383C3.88216 18.7584 3.50024 17.8364 3.50024 16.875ZM5.62524 16.75C5.5562 16.75 5.50024 16.806 5.50024 16.875C5.50024 17.306 5.67144 17.7193 5.97619 18.024C6.28094 18.3288 6.69426 18.5 7.12524 18.5C7.55621 18.5 7.96954 18.3288 8.27429 18.024C8.57903 17.7193 8.75024 17.306 8.75024 16.875C8.75024 16.806 8.69427 16.75 8.62524 16.75H5.62524ZM13.2502 19.125C13.2502 17.9514 14.2016 17 15.3752 17H18.3752C19.5488 17 20.5002 17.9514 20.5002 19.125C20.5002 20.0864 20.1183 21.0084 19.4385 21.6883C18.7587 22.3681 17.8366 22.75 16.8752 22.75C15.9138 22.75 14.9918 22.3681 14.312 21.6883C13.6322 21.0084 13.2502 20.0864 13.2502 19.125ZM15.3752 19C15.3062 19 15.2502 19.056 15.2502 19.125C15.2502 19.556 15.4214 19.9693 15.7262 20.274C16.0309 20.5788 16.4443 20.75 16.8752 20.75C17.3062 20.75 17.7195 20.5788 18.0243 20.274C18.329 19.9693 18.5002 19.556 18.5002 19.125C18.5002 19.056 18.4443 19 18.3752 19H15.3752Z"
                fill="currentColor"
            />
        </svg>

        <!-- TELEVISION ICON -->
        <svg
            v-if="icon === 'tv'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.71065 2.88611C7.04972 2.45016 7.67799 2.37162 8.11394 2.71069L12 5.73318L15.8861 2.71069C16.322 2.37162 16.9503 2.45016 17.2894 2.88611C17.6284 3.32205 17.5499 3.95033 17.1139 4.2894L14.9145 6.00005H19C20.6569 6.00005 22 7.34319 22 9.00005V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V9.00005C2 7.34319 3.34315 6.00005 5 6.00005H9.08546L6.88606 4.2894C6.45011 3.95033 6.37158 3.32205 6.71065 2.88611ZM5 8.00005C4.44772 8.00005 4 8.44776 4 9.00005V18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18V9.00005C20 8.44776 19.5523 8.00005 19 8.00005H5Z"
                fill="currentColor"
            />
        </svg>
        <!-- WIFI ICON -->
        <svg
            v-if="icon === 'wifi'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.38475 7.28445C7.99539 2.90518 16.0047 2.90518 21.6153 7.28445C22.0507 7.62427 22.1282 8.25268 21.7883 8.68804C21.4485 9.12341 20.8201 9.20087 20.3848 8.86105C15.4974 5.04632 8.5027 5.04632 3.61534 8.86105C3.17997 9.20087 2.55156 9.12341 2.21174 8.68804C1.87193 8.25268 1.94939 7.62427 2.38475 7.28445ZM16.635 14.103C13.9346 11.9969 10.0665 11.9969 7.366 14.103C6.93049 14.4426 6.30211 14.3649 5.96247 13.9294C5.62283 13.4939 5.70054 12.8655 6.13605 12.5259C9.55956 9.85595 14.4415 9.85595 17.865 12.5259C18.3005 12.8655 18.3782 13.4939 18.0386 13.9294C17.6989 14.3649 17.0705 14.4426 16.635 14.103Z"
                fill="currentColor"
            />
            <path
                d="M12.0005 19.25C11.7244 19.25 11.5005 19.0261 11.5005 18.75C11.5005 18.4739 11.7244 18.25 12.0005 18.25C12.2767 18.25 12.5005 18.4739 12.5005 18.75C12.5005 19.0261 12.2767 19.25 12.0005 19.25Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0005 20C11.3102 20 10.7505 19.4404 10.7505 18.75C10.7505 18.0596 11.3102 17.5 12.0005 17.5C12.6909 17.5 13.2505 18.0596 13.2505 18.75C13.2505 19.4404 12.6909 20 12.0005 20ZM11.5005 18.75C11.5005 19.0261 11.7244 19.25 12.0005 19.25C12.2767 19.25 12.5005 19.0261 12.5005 18.75C12.5005 18.4739 12.2767 18.25 12.0005 18.25C11.7244 18.25 11.5005 18.4739 11.5005 18.75Z"
                fill="currentColor"
            />
        </svg>
        <!-- PAID WIFI ICON -->
        <svg
            v-if="icon === 'paid_wifi'"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :class="svgClass"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.38475 7.28445C7.99539 2.90518 16.0047 2.90518 21.6153 7.28445C22.0507 7.62427 22.1282 8.25268 21.7883 8.68804C21.4485 9.12341 20.8201 9.20087 20.3848 8.86105C15.4974 5.04632 8.5027 5.04632 3.61534 8.86105C3.17997 9.20087 2.55156 9.12341 2.21174 8.68804C1.87193 8.25268 1.94939 7.62427 2.38475 7.28445ZM16.635 14.103C13.9346 11.9969 10.0665 11.9969 7.366 14.103C6.93049 14.4426 6.30211 14.3649 5.96247 13.9294C5.62283 13.4939 5.70054 12.8655 6.13605 12.5259C9.55956 9.85595 14.4415 9.85595 17.865 12.5259C18.3005 12.8655 18.3782 13.4939 18.0386 13.9294C17.6989 14.3649 17.0705 14.4426 16.635 14.103Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                d="M12.0005 19.25C11.7244 19.25 11.5005 19.0261 11.5005 18.75C11.5005 18.4739 11.7244 18.25 12.0005 18.25C12.2767 18.25 12.5005 18.4739 12.5005 18.75C12.5005 19.0261 12.2767 19.25 12.0005 19.25Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.0005 20C11.3102 20 10.7505 19.4404 10.7505 18.75C10.7505 18.0596 11.3102 17.5 12.0005 17.5C12.6909 17.5 13.2505 18.0596 13.2505 18.75C13.2505 19.4404 12.6909 20 12.0005 20ZM11.5005 18.75C11.5005 19.0261 11.7244 19.25 12.0005 19.25C12.2767 19.25 12.5005 19.0261 12.5005 18.75C12.5005 18.4739 12.2767 18.25 12.0005 18.25C11.7244 18.25 11.5005 18.4739 11.5005 18.75Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.2046 14.625C21.6878 14.625 22.0796 15.0168 22.0796 15.5V15.779C22.6077 15.9426 23.0741 16.2548 23.3902 16.6918C23.6733 17.0834 23.5854 17.6304 23.1938 17.9136C22.8022 18.1968 22.2552 18.1089 21.972 17.7173C21.8654 17.5698 21.5976 17.3977 21.2046 17.3977H21.0152C20.7816 17.3977 20.5989 17.4742 20.4904 17.561C20.3835 17.6465 20.375 17.7136 20.375 17.7348V17.7869C20.375 17.8238 20.4097 17.9896 20.6985 18.1052L22.3606 18.77C23.1425 19.0828 23.7841 19.7924 23.7841 20.7131C23.7841 21.777 22.9862 22.4901 22.0796 22.7465V23C22.0796 23.4832 21.6878 23.875 21.2046 23.875C20.7213 23.875 20.3296 23.4832 20.3296 23V22.721C19.8014 22.5574 19.3351 22.2452 19.019 21.8082C18.7359 21.4166 18.8238 20.8696 19.2154 20.5864C19.607 20.3032 20.154 20.3911 20.4371 20.7827C20.5437 20.9302 20.8116 21.1023 21.2046 21.1023H21.3289C21.5805 21.1023 21.7794 21.02 21.8997 20.9237C22.0184 20.8288 22.0341 20.7488 22.0341 20.7131C22.0341 20.6762 21.9995 20.5104 21.7107 20.3948L20.0486 19.73C19.2667 19.4172 18.625 18.7076 18.625 17.7869V17.7348C18.625 16.6766 19.4306 15.9772 20.3296 15.7387V15.5C20.3296 15.0168 20.7213 14.625 21.2046 14.625Z"
                fill="currentColor"
            />
        </svg>

        <!-- SHOWER ICON -->
        <svg
            v-if="icon === 'shower'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.875 23.2503C5.49632 23.2503 6 22.7466 6 22.1253C6 21.504 5.49632 21.0003 4.875 21.0003C4.25368 21.0003 3.75 21.504 3.75 22.1253C3.75 22.7466 4.25368 23.2503 4.875 23.2503Z"
                fill="currentColor"
            />
            <path
                d="M7.875 20.2503C8.49632 20.2503 9 19.7466 9 19.1253C9 18.504 8.49632 18.0003 7.875 18.0003C7.25368 18.0003 6.75 18.504 6.75 19.1253C6.75 19.7466 7.25368 20.2503 7.875 20.2503Z"
                fill="currentColor"
            />
            <path
                d="M1.875 20.2503C2.49632 20.2503 3 19.7466 3 19.1253C3 18.504 2.49632 18.0003 1.875 18.0003C1.25368 18.0003 0.75 18.504 0.75 19.1253C0.75 19.7466 1.25368 20.2503 1.875 20.2503Z"
                fill="currentColor"
            />
            <path
                d="M4.875 17.2503C5.49632 17.2503 6 16.7466 6 16.1253C6 15.504 5.49632 15.0003 4.875 15.0003C4.25368 15.0003 3.75 15.504 3.75 16.1253C3.75 16.7466 4.25368 17.2503 4.875 17.2503Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.9602 3.86914C23.9602 4.42143 23.5125 4.86914 22.9602 4.86914L20.9602 4.86914C20.695 4.86914 20.4406 4.9745 20.2531 5.16203L18.2799 7.13525L17.6941 17.3465C17.5457 19.9329 14.4095 21.1279 12.5777 19.296L4.73401 11.4524C2.90509 9.62346 4.09301 6.49214 6.6748 6.3365L16.8645 5.72221L18.8389 3.74782C19.4015 3.18521 20.1645 2.86914 20.9602 2.86914L22.9602 2.86914C23.5125 2.86914 23.9602 3.31686 23.9602 3.86914ZM16.2405 7.76345L6.79516 8.33287C5.93456 8.38475 5.53859 9.42853 6.14823 10.0382L13.9919 17.8818C14.6025 18.4924 15.6479 18.0941 15.6974 17.232L16.2405 7.76345Z"
                fill="currentColor"
            />
        </svg>
        <!-- PAID SHOWER ICON -->
        <svg
            v-if="icon === 'paid_shower'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.2045 14.6253C21.6878 14.6253 22.0795 15.0168 22.0795 15.5V15.7793C22.6077 15.9428 23.0741 16.2548 23.3901 16.6918C23.6733 17.0834 23.5854 17.6304 23.1938 17.9136C22.8022 18.1968 22.2552 18.1089 21.972 17.7173C21.8654 17.5698 21.5975 17.3977 21.2045 17.3977H21.0152C20.7815 17.3977 20.5989 17.4742 20.4904 17.5613C20.3835 17.6468 20.375 17.7138 20.375 17.7351V17.7872C20.375 17.8238 20.4097 17.9896 20.6985 18.1054L22.3605 18.77C23.1424 19.0828 23.7841 19.7924 23.7841 20.7131C23.7841 21.777 22.9861 22.4901 22.0795 22.7465V23C22.0795 23.4832 21.6878 23.8753 21.2045 23.8753C20.7213 23.8753 20.3295 23.4832 20.3295 23V22.7213C19.8014 22.5577 19.335 22.2455 19.019 21.8084C18.7358 21.4168 18.8237 20.8698 19.2153 20.5867C19.6069 20.3035 20.1539 20.3914 20.4371 20.7827C20.5437 20.9302 20.8116 21.1023 21.2045 21.1023H21.3289C21.5805 21.1023 21.7794 21.02 21.8997 20.9237C22.0183 20.8288 22.0341 20.7488 22.0341 20.7131C22.0341 20.6762 21.9994 20.5104 21.7106 20.3948L20.0485 19.73C19.2667 19.4175 18.625 18.7079 18.625 17.7869V17.7348C18.625 16.6768 19.4306 15.9775 20.3295 15.7389V15.5C20.3295 15.0168 20.7213 14.6253 21.2045 14.6253Z"
                fill="currentColor"
            />
            <path
                d="M4.875 23.2503C5.49632 23.2503 6 22.7466 6 22.1253C6 21.504 5.49632 21.0003 4.875 21.0003C4.25368 21.0003 3.75 21.504 3.75 22.1253C3.75 22.7466 4.25368 23.2503 4.875 23.2503Z"
                fill="currentColor"
            />
            <path
                d="M7.875 20.2503C8.49632 20.2503 9 19.7466 9 19.1253C9 18.504 8.49632 18.0003 7.875 18.0003C7.25368 18.0003 6.75 18.504 6.75 19.1253C6.75 19.7466 7.25368 20.2503 7.875 20.2503Z"
                fill="currentColor"
            />
            <path
                d="M1.875 20.2503C2.49632 20.2503 3 19.7466 3 19.1253C3 18.504 2.49632 18.0003 1.875 18.0003C1.25368 18.0003 0.75 18.504 0.75 19.1253C0.75 19.7466 1.25368 20.2503 1.875 20.2503Z"
                fill="currentColor"
            />
            <path
                d="M4.875 17.2503C5.49632 17.2503 6 16.7466 6 16.1253C6 15.504 5.49632 15.0003 4.875 15.0003C4.25368 15.0003 3.75 15.504 3.75 16.1253C3.75 16.7466 4.25368 17.2503 4.875 17.2503Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M23.9602 3.86914C23.9602 4.42143 23.5125 4.86914 22.9602 4.86914L20.9602 4.86914C20.695 4.86914 20.4406 4.9745 20.2531 5.16203L18.2799 7.13525L17.6941 17.3465C17.5457 19.9329 14.4095 21.1279 12.5777 19.296L4.73401 11.4524C2.90509 9.62346 4.09301 6.49214 6.6748 6.3365L16.8645 5.72221L18.8389 3.74782C19.4015 3.18521 20.1645 2.86914 20.9602 2.86914L22.9602 2.86914C23.5125 2.86914 23.9602 3.31686 23.9602 3.86914ZM16.2405 7.76345L6.79516 8.33287C5.93456 8.38475 5.53859 9.42853 6.14823 10.0382L13.9919 17.8818C14.6025 18.4924 15.6479 18.0941 15.6974 17.232L16.2405 7.76345Z"
                fill="currentColor"
            />
        </svg>
        <!-- FAMILY ROOM ICON -->
        <svg
            v-if="icon === 'family_room'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M8.625 13.125C9.24632 13.125 9.75 12.6214 9.75 12C9.75 11.3787 9.24632 10.875 8.625 10.875C8.00368 10.875 7.5 11.3787 7.5 12C7.5 12.6214 8.00368 13.125 8.625 13.125Z"
                fill="currentColor"
            />
            <path
                d="M15.375 13.125C15.9963 13.125 16.5 12.6214 16.5 12C16.5 11.3787 15.9963 10.875 15.375 10.875C14.7537 10.875 14.25 11.3787 14.25 12C14.25 12.6214 14.7537 13.125 15.375 13.125Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.52594 15.2217C8.81772 14.7528 9.43438 14.6092 9.9033 14.901C10.5326 15.2925 11.2589 15.5 12 15.5C12.7411 15.5 13.4674 15.2925 14.0967 14.901C14.5656 14.6092 15.1823 14.7528 15.4741 15.2217C15.7658 15.6907 15.6222 16.3073 15.1533 16.5991C14.2069 17.1879 13.1146 17.5 12 17.5C10.8854 17.5 9.79306 17.1879 8.8467 16.5991C8.37778 16.3073 8.23417 15.6907 8.52594 15.2217Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12 2.00004C6.47715 2.00004 2 6.47719 2 12C2 17.5229 6.47715 22 12 22C17.5228 22 22 17.5229 22 12C22 6.47719 17.5228 2.00004 12 2.00004ZM12 20C7.58172 20 4 16.4183 4 12C4 8.23553 6.60017 5.07833 10.1025 4.22641C9.9311 4.62216 9.80867 4.99272 9.72126 5.3205C9.61335 5.72517 9.55818 6.06686 9.5299 6.31422C9.51575 6.43807 9.50828 6.53878 9.50435 6.61255C9.50238 6.64945 9.50129 6.67967 9.5007 6.70272L9.50013 6.7319L9.50003 6.74237L9.50001 6.74656L9.5 6.74839L9.5 6.75004C9.5 7.41308 9.76339 8.04896 10.2322 8.5178C10.7011 8.98664 11.337 9.25004 12 9.25004C12.663 9.25004 13.2989 8.98664 13.7678 8.5178C14.2366 8.04896 14.5 7.41308 14.5 6.75004C14.5 6.19775 14.0523 5.75004 13.5 5.75004C12.9477 5.75004 12.5 6.19775 12.5 6.75004C12.5 6.88264 12.4473 7.00982 12.3536 7.10359C12.2598 7.19736 12.1326 7.25004 12 7.25004C11.8674 7.25004 11.7402 7.19736 11.6464 7.10359C11.5538 7.01093 11.5013 6.88522 11.5 6.75432C11.5002 6.74899 11.5005 6.7371 11.5015 6.71907C11.5034 6.68297 11.5077 6.62255 11.517 6.54132C11.5356 6.37853 11.5741 6.13428 11.6537 5.83582C11.7873 5.33506 12.0345 4.68792 12.4925 4.01495C16.6814 4.26938 20 7.74716 20 12C20 16.4183 16.4183 20 12 20ZM9.75 12C9.75 12.6214 9.24632 13.125 8.625 13.125C8.00368 13.125 7.5 12.6214 7.5 12C7.5 11.3787 8.00368 10.875 8.625 10.875C9.24632 10.875 9.75 11.3787 9.75 12ZM16.5 12C16.5 12.6214 15.9963 13.125 15.375 13.125C14.7537 13.125 14.25 12.6214 14.25 12C14.25 11.3787 14.7537 10.875 15.375 10.875C15.9963 10.875 16.5 11.3787 16.5 12ZM9.9033 14.901C9.43438 14.6092 8.81772 14.7528 8.52594 15.2217C8.23417 15.6907 8.37778 16.3073 8.8467 16.5991C9.79306 17.1879 10.8854 17.5 12 17.5C13.1146 17.5 14.2069 17.1879 15.1533 16.5991C15.6222 16.3073 15.7658 15.6907 15.4741 15.2217C15.1823 14.7528 14.5656 14.6092 14.0967 14.901C13.4674 15.2925 12.7411 15.5 12 15.5C11.2589 15.5 10.5326 15.2925 9.9033 14.901Z"
                fill="currentColor"
            />
        </svg>
        <!-- CONFERENCE ROOM ICON -->
        <svg
            v-if="icon === 'conference_room'"
            :class="svgClass"
            width="22"
            height="18"
            viewBox="0 0 22 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.5 0C10.0523 0 10.5 0.447715 10.5 1H18C18.5523 1 19 1.44772 19 2C19 2.55228 18.5523 3 18 3C18 3.55228 17.5523 4 17 4C16.4477 4 16 3.55228 16 3H3V13H8C8.55228 13 9 13.4477 9 14C9 14.5523 8.55228 15 8 15H1C0.447715 15 0 14.5523 0 14C0 13.4477 0.447715 13 1 13V3C0.447715 3 0 2.55228 0 2C0 1.44772 0.447715 1 1 1H8.5C8.5 0.447715 8.94772 0 9.5 0ZM16 8C15.4477 8 15 8.44772 15 9C15 9.55229 15.4477 10 16 10C16.5523 10 17 9.55229 17 9C17 8.44772 16.5523 8 16 8ZM13 9C13 7.34315 14.3431 6 16 6C17.6569 6 19 7.34315 19 9C19 10.6569 17.6569 12 16 12C14.3431 12 13 10.6569 13 9ZM13.1222 16H18.8778C18.3417 15.1342 17.285 14.5 16 14.5C14.715 14.5 13.6583 15.1342 13.1222 16ZM19.1447 16C19.1467 16 19.1468 15.9997 19.1447 16V16ZM12.8556 16C12.8535 15.9997 12.8536 16 12.8556 16V16ZM11.1132 15.5347C11.9085 13.7147 13.8256 12.5 16 12.5C18.1744 12.5 20.0915 13.7147 20.8868 15.5347C21.1693 16.1812 21.0196 16.8423 20.6428 17.3035C20.2835 17.7434 19.729 18 19.1447 18H12.8553C12.271 18 11.7165 17.7434 11.3572 17.3035C10.9804 16.8423 10.8307 16.1812 11.1132 15.5347Z"
                fill="currentColor"
            />
        </svg>

        <!-- PAID CONFERENCE ROOM ICON -->
        <svg
            v-if="icon === 'paid_conference_room'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                d="M3 5H18M3 5V11.5M3 5H2M18 5H19M18 5V6M10 17H7.5M10.5 5V4M19 12C19 13.1046 18.1046 14 17 14C15.8954 14 15 13.1046 15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12ZM17 16.5C15.1898 16.5 13.6528 17.5089 13.0295 18.9351C12.7926 19.4774 13.2636 20 13.8553 20H20.1447C20.7364 20 21.2075 19.4774 20.9705 18.9351C20.3472 17.5089 18.8102 16.5 17 16.5Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                id="vector_2"
                d="M3.00533 15.1818V14.5M3.00533 21.3182V22M4.48183 16.2045C4.18711 15.797 3.63625 15.5227 3.00533 15.5227H2.81593C1.97914 15.5227 1.30078 16.0654 1.30078 16.7348V16.7869C1.30078 17.2657 1.63895 17.7034 2.17429 17.9176L3.83636 18.5824C4.37171 18.7966 4.70987 19.2343 4.70987 19.7131C4.70987 20.4113 4.00239 20.9773 3.12967 20.9773H3.00533C2.3744 20.9773 1.82354 20.703 1.52882 20.2955"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
        <!-- DECK ICON -->
        <svg
            v-if="icon === 'deck'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M12.5048 3.45067C12.1935 3.26905 11.8084 3.26905 11.4971 3.45067L5.2974 7.06716C4.85656 7.32432 5.03897 7.99905 5.54934 7.99905H18.4526C18.9629 7.99905 19.1454 7.32431 18.7045 7.06716L12.5048 3.45067ZM10.4893 1.72312C11.4234 1.17823 12.5785 1.17823 13.5126 1.72312L19.7123 5.3396C21.9165 6.6254 21.0044 9.99905 18.4526 9.99905H13.001V20.999C13.001 21.5513 12.5532 21.999 12.001 21.999C11.4487 21.999 11.001 21.5513 11.001 20.999V9.99905H5.54934C2.9975 9.99905 2.08544 6.62539 4.02177 5.3396L10.4893 1.72312ZM3.12207 12.1636C3.66545 12.0648 4.18603 12.4252 4.28482 12.9686L4.83553 15.9975H6.00096C7.65781 15.9975 9.00096 17.3406 9.00096 18.9975V20.9975C9.00096 21.5498 8.55324 21.9975 8.00096 21.9975C7.44867 21.9975 7.00096 21.5498 7.00096 20.9975V18.9975C7.00096 18.4452 6.55324 17.9975 6.00096 17.9975H5.00096V20.9975C5.00096 21.5498 4.55324 21.9975 4.00096 21.9975C3.44867 21.9975 3.00096 21.5498 3.00096 20.9975V17.0877L2.31708 13.3264C2.21829 12.783 2.57869 12.2624 3.12207 12.1636ZM20.8798 12.1652C21.4232 12.264 21.7836 12.7846 21.6848 13.3279L21.001 17.0892V20.999C21.001 21.5513 20.5532 21.999 20.001 21.999C19.4487 21.999 19.001 21.5513 19.001 20.999V17.999H18.001C17.4487 17.999 17.001 18.4468 17.001 18.999V20.999C17.001 21.5513 16.5532 21.999 16.001 21.999C15.4487 21.999 15.001 21.5513 15.001 20.999V18.999C15.001 17.3422 16.3441 15.999 18.001 15.999H19.1664L19.7171 12.9702C19.8159 12.4268 20.3365 12.0664 20.8798 12.1652Z"
                fill="currentColor"
            />
        </svg>
        <!-- MONITORS ICON -->
        <svg
            v-if="icon === 'monitor'"
            :class="svgClass"
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V3H3C1.34315 3 0 4.34315 0 6V16C0 17.6569 1.34315 19 3 19H17C18.6569 19 20 17.6569 20 16V6C20 4.34315 18.6569 3 17 3H15V1C15 0.447715 14.5523 0 14 0C13.4477 0 13 0.447715 13 1V3H7V1ZM2 6C2 5.44772 2.44772 5 3 5H17C17.5523 5 18 5.44772 18 6V16C18 16.5523 17.5523 17 17 17H3C2.44772 17 2 16.5523 2 16V6ZM6.866 14.7557L15.4698 12.4358C15.7976 12.3436 16.0459 12.1515 16.215 11.8596C16.384 11.5677 16.4224 11.2579 16.3302 10.9301C16.238 10.6023 16.0459 10.3539 15.754 10.1849C15.4621 10.0159 15.1523 9.97753 14.8245 10.0697L12.2126 10.7765L7.92611 7.16593C7.83393 7.08399 7.72382 7.03278 7.59578 7.01229C7.46775 6.99181 7.3474 6.99693 7.23473 7.02766L6.91209 7.10447C6.64578 7.17617 6.47166 7.33749 6.38972 7.58844C6.30777 7.83938 6.34874 8.0724 6.51263 8.2875L9.01695 11.6368L6.866 12.2053L5.39106 10.9762C5.30912 10.9045 5.2195 10.861 5.12219 10.8456C5.02489 10.8302 4.92502 10.8328 4.82259 10.8533L4.46922 10.9455C4.26437 10.9967 4.12353 11.1196 4.04671 11.3142C3.96989 11.5088 3.98782 11.6932 4.10049 11.8673L5.49861 14.2026C5.642 14.4382 5.83917 14.6072 6.09012 14.7096C6.34106 14.812 6.59969 14.8274 6.866 14.7557Z"
                fill="currentColor"
            />
        </svg>

        <!-- SMOKING ICON -->
        <svg
            v-if="icon === 'smoking'"
            :class="svgClass"
            width="22"
            height="17"
            viewBox="0 0 22 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.8362 0.594111C14.0605 0.0894269 14.6515 -0.137866 15.1561 0.086438L14.75 1.00025C15.1561 0.0864381 15.157 0.0868101 15.1578 0.0871857L15.1595 0.0879567L15.1631 0.0895697L15.1708 0.0930816L15.1882 0.101277C15.2006 0.107269 15.2148 0.114347 15.2306 0.122578C15.2622 0.139018 15.3003 0.160196 15.3433 0.186677C15.4291 0.239452 15.5365 0.314569 15.6517 0.416903C15.8838 0.623261 16.1474 0.941117 16.3191 1.39913C16.6725 2.34136 16.5453 3.5984 15.6216 5.24051C14.8578 6.5984 14.985 7.21636 15.0535 7.39913C15.0927 7.50362 15.1455 7.56076 15.1771 7.58878C15.1871 7.59772 15.1952 7.60378 15.2 7.60718C15.6738 7.84545 15.8815 8.41656 15.6638 8.90639C15.4395 9.41107 14.8485 9.63837 14.3439 9.41406L14.75 8.50025C14.3439 9.41406 14.343 9.41369 14.3422 9.41331L14.3405 9.41254L14.3369 9.41093L14.3292 9.40742L14.3118 9.39922C14.2994 9.39323 14.2852 9.38615 14.2694 9.37792C14.2378 9.36148 14.1997 9.3403 14.1567 9.31382C14.0709 9.26105 13.9635 9.18593 13.8483 9.0836C13.6162 8.87724 13.3526 8.55938 13.1809 8.10137C12.8275 7.15913 12.9547 5.9021 13.8784 4.25999C14.6422 2.9021 14.515 2.28413 14.4465 2.10137C14.4073 1.99688 14.3545 1.93974 14.3229 1.91172C14.3129 1.90278 14.3048 1.89672 14.3 1.89331C13.8262 1.65504 13.6185 1.08394 13.8362 0.594111ZM17.5862 0.594111C17.8105 0.0894269 18.4015 -0.137866 18.9061 0.086438L18.5 1.00025C18.9061 0.0864381 18.907 0.0868101 18.9078 0.0871857L18.9095 0.0879567L18.9131 0.0895697L18.9208 0.0930816L18.9382 0.101277C18.9506 0.107269 18.9648 0.114347 18.9806 0.122578C19.0122 0.139018 19.0503 0.160196 19.0933 0.186677C19.1791 0.239452 19.2865 0.314569 19.4017 0.416903C19.6338 0.623261 19.8974 0.941117 20.0691 1.39913C20.4225 2.34136 20.2953 3.5984 19.3716 5.24051C18.6078 6.5984 18.735 7.21636 18.8035 7.39913C18.8427 7.50362 18.8955 7.56076 18.9271 7.58878C18.9371 7.59772 18.9452 7.60378 18.95 7.60718C19.4238 7.84545 19.6315 8.41656 19.4138 8.90639C19.1895 9.41107 18.5985 9.63837 18.0939 9.41406L18.5 8.50025C18.0939 9.41406 18.093 9.41369 18.0922 9.41331L18.0905 9.41254L18.0869 9.41093L18.0792 9.40742L18.0618 9.39922C18.0494 9.39323 18.0352 9.38615 18.0194 9.37792C17.9878 9.36148 17.9497 9.3403 17.9067 9.31382C17.8209 9.26105 17.7135 9.18593 17.5983 9.0836C17.3662 8.87724 17.1026 8.55938 16.9309 8.10137C16.5775 7.15913 16.7047 5.9021 17.6284 4.25999C18.3922 2.9021 18.265 2.28413 18.1965 2.10137C18.1573 1.99688 18.1045 1.93974 18.0729 1.91172C18.0629 1.90278 18.0548 1.89672 18.05 1.89332C17.5762 1.65505 17.3685 1.08394 17.5862 0.594111ZM3 12.5002C2.44772 12.5002 2 12.948 2 13.5002V14.0002C2 14.5525 2.44772 15.0002 3 15.0002H5V12.5002H3ZM3 10.5002C1.34315 10.5002 0 11.8434 0 13.5002V14.0002C0 15.6571 1.34315 17.0002 3 17.0002H19C20.6569 17.0002 22 15.6571 22 14.0002V13.5002C22 11.8434 20.6569 10.5002 19 10.5002H3ZM7 12.5002V15.0002H19C19.5523 15.0002 20 14.5525 20 14.0002V13.5002C20 12.948 19.5523 12.5002 19 12.5002H7Z"
                fill="currentColor"
            />
        </svg>

        <!-- SPA ICON -->
        <svg
            v-if="icon === 'spa'"
            :class="svgClass"
            width="22"
            height="17"
            viewBox="0 0 22 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.08828 0.699354C9.84021 -0.233117 11.2491 -0.233119 12.0011 0.699353C13.5358 2.60257 14.4769 5.00684 14.5412 7.62619C16.0721 6.93321 17.7161 6.64343 19.3297 6.73245C20.5359 6.799 21.3536 7.9665 21.0039 9.12277C20.3605 11.2499 19.0244 13.1862 17.0635 14.5592C15.1119 15.9257 12.8477 16.5199 10.6387 16.4043L10.448 16.4045C8.23864 16.5205 5.97381 15.9264 4.02177 14.5596C2.06089 13.1866 0.724764 11.2502 0.0814084 9.12312C-0.26831 7.96685 0.549394 6.79935 1.75556 6.73281C3.37061 6.64371 5.01612 6.93407 6.54815 7.62836C6.61195 5.00817 7.55313 2.6031 9.08828 0.699354ZM6.73285 9.99534C5.28656 9.08067 3.65586 8.66905 2.05162 8.7216C2.589 10.3648 3.64293 11.8528 5.16892 12.9213C6.19298 13.6383 7.32183 14.091 8.47585 14.294C7.62389 13.0186 7.01961 11.5626 6.73285 9.99534ZM12.6143 14.2928C13.4665 13.0168 14.0707 11.5601 14.3571 9.99202C15.8022 9.07943 17.4312 8.66875 19.0337 8.72125C18.4963 10.3644 17.4424 11.8524 15.9164 12.9209C14.8938 13.637 13.7666 14.0894 12.6143 14.2928ZM10.5447 2.08158C9.29087 3.69148 8.54468 5.71397 8.54468 7.91332C8.54468 8.37258 8.5772 8.82367 8.63992 9.26454C8.8779 10.9374 9.55194 12.4703 10.5447 13.7451C11.5234 12.4883 12.1924 10.9806 12.4391 9.33526C12.5086 8.87194 12.5447 8.39716 12.5447 7.91332C12.5447 5.71397 11.7985 3.69148 10.5447 2.08158Z"
                fill="currentColor"
            />
        </svg>
        <!-- PAID SPA ICON -->
        <svg
            v-if="icon === 'paid_spa'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :pathClass="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5434 4.28529C11.2953 3.35282 12.7042 3.35282 13.4562 4.28529C14.9909 6.18851 15.932 8.59277 15.9962 11.2121C17.5271 10.5191 19.1712 10.2294 20.7848 10.3184C21.991 10.3849 22.8087 11.5524 22.459 12.7087C22.4126 12.862 22.3626 13.0143 22.3091 13.1655C22.1247 13.6861 21.5533 13.9587 21.0327 13.7743C20.512 13.59 20.2395 13.0185 20.4238 12.4979C20.4462 12.4345 20.4679 12.371 20.4887 12.3072C18.8862 12.2547 17.2573 12.6654 15.8122 13.578C15.5258 15.146 14.9215 16.6027 14.0694 17.8787C14.8567 17.7397 15.632 17.4846 16.3699 17.1089C16.862 16.8583 17.4642 17.0541 17.7148 17.5463C17.9653 18.0384 17.7695 18.6405 17.2774 18.8911C15.6365 19.7266 13.8474 20.082 12.0938 19.9902L11.9031 19.9905C9.69372 20.1065 7.42888 19.5123 5.47685 18.1455C3.51597 16.7725 2.17984 14.8362 1.53649 12.7091C1.18677 11.5528 2.00447 10.3853 3.21064 10.3187C4.82569 10.2296 6.47119 10.52 8.00323 11.2143C8.06702 8.59411 9.00821 6.18904 10.5434 4.28529ZM8.18793 13.5813C6.74164 12.6666 5.11093 12.255 3.5067 12.3075C4.04408 13.9507 5.09801 15.4387 6.624 16.5072C7.64806 17.2243 8.77691 17.6769 9.93093 17.8799C9.07896 16.6046 8.47469 15.1485 8.18793 13.5813ZM11.9998 5.66752C10.7459 7.27742 9.99976 9.2999 9.99976 11.4993C9.99976 11.9585 10.0323 12.4096 10.095 12.8505C10.333 14.5234 11.007 16.0563 11.9998 17.331C12.9785 16.0742 13.6475 14.5665 13.8942 12.9212C13.9637 12.4579 13.9998 11.9831 13.9998 11.4993C13.9998 9.2999 13.2536 7.27742 11.9998 5.66752Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.2044 14.625C21.6876 14.625 22.0794 15.0168 22.0794 15.5V15.779C22.6075 15.9426 23.0739 16.2548 23.3899 16.6918C23.6731 17.0834 23.5852 17.6304 23.1936 17.9136C22.802 18.1968 22.255 18.1089 21.9718 17.7173C21.8652 17.5698 21.5974 17.3977 21.2044 17.3977H21.015C20.7813 17.3977 20.5987 17.4742 20.4902 17.561C20.3833 17.6465 20.3748 17.7136 20.3748 17.7348V17.7869C20.3748 17.8238 20.4095 17.9896 20.6983 18.1052L22.3604 18.77C23.1423 19.0828 23.7839 19.7924 23.7839 20.7131C23.7839 21.777 22.986 22.4901 22.0794 22.7465V23C22.0794 23.4832 21.6876 23.875 21.2044 23.875C20.7211 23.875 20.3294 23.4832 20.3294 23V22.721C19.8012 22.5574 19.3348 22.2452 19.0188 21.8082C18.7357 21.4166 18.8236 20.8696 19.2152 20.5864C19.6068 20.3032 20.1538 20.3911 20.4369 20.7827C20.5435 20.9302 20.8114 21.1023 21.2044 21.1023H21.3287C21.5803 21.1023 21.7792 21.02 21.8995 20.9237C22.0181 20.8288 22.0339 20.7488 22.0339 20.7131C22.0339 20.6762 21.9992 20.5104 21.7104 20.3948L20.0484 19.73C19.2665 19.4172 18.6248 18.7076 18.6248 17.7869V17.7348C18.6248 16.6766 19.4306 15.9772 20.3294 15.7387V15.5C20.3294 15.0168 20.7211 14.625 21.2044 14.625Z"
                fill="currentColor"
            />
        </svg>
        <!-- PRIVATE ROOM ICON -->
        <svg
            v-if="icon === 'private_room'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 3.5C3.55228 3.5 4 3.94772 4 4.5V8H18.0007C18.9954 8 19.9711 8.39679 20.7018 9.02001C21.4342 9.64477 22 10.5709 22 11.6667V19.5C22 20.0523 21.5523 20.5 21 20.5C20.4477 20.5 20 20.0523 20 19.5V4.5C20 3.94772 20.4477 3.5 21 3.5C21.5523 3.5 22 3.94772 22 4.5V8H4V4.5C4 3.94772 4.44772 3.5 5 3.5C5.55228 3.5 6 3.94772 6 4.5V19.5C6 20.0523 5.55228 20.5 5 20.5C4.44772 20.5 4 20.0523 4 19.5V8H3V4.5ZM4 15H7V10H4V15ZM9 10V15H20V11.6667C20 11.2891 19.8028 10.8819 19.4039 10.5417C19.0032 10.1999 18.4792 10 18.0007 10H9Z"
                fill="currentColor"
            />
        </svg>
        <!-- PAID PRIVATE ROOM ICON -->
        <svg
            v-if="icon === 'paid_private_room'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M3 3.5C3.55228 3.5 4 3.94772 4 4.5V8H18.0007C18.9954 8 19.9711 8.39679 20.7018 9.02001C21.4342 9.64477 22 10.5709 22 11.6667V12.5C22 13.0523 21.5523 13.5 21 13.5C20.4477 13.5 20 13.0523 20 12.5V11.6667C20 11.2891 19.8028 10.8819 19.4039 10.5417C19.0032 10.1999 18.4792 10 18.0007 10H9V15H16.75C17.3023 15 17.75 15.4477 17.75 16C17.75 16.5523 17.3023 17 16.75 17H4V19.5C4 20.0523 3.55228 20.5 3 20.5C2.44772 20.5 2 20.0523 2 19.5V4.5C2 3.94772 2.44772 3.5 3 3.5ZM4 15H7V10H4V15Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.2045 14.625C21.6878 14.625 22.0795 15.0168 22.0795 15.5V15.779C22.6077 15.9426 23.0741 16.2548 23.3901 16.6918C23.6733 17.0834 23.5854 17.6304 23.1938 17.9136C22.8022 18.1968 22.2552 18.1089 21.972 17.7173C21.8654 17.5698 21.5975 17.3977 21.2045 17.3977H21.0152C20.7815 17.3977 20.5989 17.4742 20.4904 17.561C20.3835 17.6465 20.375 17.7136 20.375 17.7348V17.7869C20.375 17.8238 20.4097 17.9896 20.6985 18.1052L22.3605 18.77C23.1424 19.0828 23.7841 19.7924 23.7841 20.7131C23.7841 21.777 22.9861 22.4901 22.0795 22.7465V23C22.0795 23.4832 21.6878 23.875 21.2045 23.875C20.7213 23.875 20.3295 23.4832 20.3295 23V22.721C19.8014 22.5574 19.335 22.2452 19.019 21.8082C18.7358 21.4166 18.8237 20.8696 19.2153 20.5864C19.6069 20.3032 20.1539 20.3911 20.4371 20.7827C20.5437 20.9302 20.8116 21.1023 21.2045 21.1023H21.3289C21.5805 21.1023 21.7794 21.02 21.8997 20.9237C22.0183 20.8288 22.0341 20.7488 22.0341 20.7131C22.0341 20.6762 21.9994 20.5104 21.7106 20.3948L20.0485 19.73C19.2667 19.4172 18.625 18.7076 18.625 17.7869V17.7348C18.625 16.6766 19.4306 15.9772 20.3295 15.7387V15.5C20.3295 15.0168 20.7213 14.625 21.2045 14.625Z"
                fill="currentColor"
            />
        </svg>
        <!-- PRAYER ROOM ICON -->
        <svg
            v-if="icon === 'prayer_room'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M13.4696 2.55705C13.4193 2.51982 13.3583 2.49982 13.2958 2.50001L13.2928 2.50001C13.2155 2.50001 13.1414 2.53067 13.0866 2.58527C13.0321 2.6397 13.0013 2.7135 13.0009 2.79054V14.8827C13.0009 14.8826 13.0009 14.8827 13.0009 14.8827C13.001 15.4114 13.2105 15.9187 13.5835 16.2933C13.5833 16.2932 13.5837 16.2935 13.5835 16.2933L14.6986 17.4085L17.5148 14.7941C17.2331 14.473 17.0227 14.0949 16.8985 13.6847L13.5751 2.70664C13.5751 2.70663 13.5751 2.70664 13.5751 2.70664C13.5569 2.64674 13.5201 2.59427 13.4696 2.55705ZM18.9253 16.2136L16.1285 18.81L17.2807 19.9189C17.6732 20.2967 18.296 20.2907 18.6812 19.9055L19.9199 18.6668C20.3025 18.2843 20.3114 17.6668 19.94 17.2733L19.1839 16.4722L18.9253 16.2136ZM13.2913 0.500006C13.7837 0.498868 14.2633 0.656372 14.6591 0.949199C15.0553 1.24232 15.3465 1.65541 15.4893 2.12712L18.8127 13.1052C18.8604 13.2628 18.9463 13.4061 19.0627 13.5226L20.6083 15.0682C20.6152 15.075 20.6219 15.0819 20.6285 15.0889L21.3945 15.9006C22.5086 17.081 22.4818 18.9333 21.3341 20.081L20.0954 21.3197C18.9397 22.4755 17.0714 22.4933 15.8938 21.3599L13.9794 19.5174L13.9657 19.504L12.1672 17.7055C11.4204 16.9559 11.0011 15.941 11.0009 14.883V2.78689C11.0022 2.17991 11.2443 1.59825 11.674 1.16952C12.1033 0.741132 12.6849 0.500396 13.2913 0.500006ZM13.2913 0.500006C13.2918 0.500006 13.2923 0.500006 13.2928 0.500006L13.2928 1.50001L13.2898 0.50001C13.2903 0.500009 13.2908 0.500007 13.2913 0.500006Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.5322 2.55705C10.5825 2.51983 10.6435 2.49982 10.7061 2.50001L10.7091 2.50001C10.7864 2.50001 10.8605 2.53067 10.9152 2.58527C10.9698 2.63971 11.0006 2.7135 11.0009 2.79055V14.883C11.0009 14.8829 11.0009 14.883 11.0009 14.883C11.0008 15.4117 10.7913 15.9187 10.4184 16.2934C10.4182 16.2935 10.4186 16.2932 10.4184 16.2934L9.30326 17.4085L6.48707 14.7941C6.76876 14.473 6.97917 14.0949 7.10336 13.6847L10.4268 2.70664C10.4268 2.70665 10.4268 2.70664 10.4268 2.70664C10.4449 2.64674 10.4819 2.59427 10.5322 2.55705ZM5.07656 16.2136L7.87336 18.81L6.72118 19.9189C6.32863 20.2967 5.70588 20.2907 5.32063 19.9055L4.08196 18.6668C3.69939 18.2843 3.69047 17.6668 4.06182 17.2733L4.81795 16.4722L5.07656 16.2136ZM10.7105 0.500012C10.2182 0.498874 9.73856 0.656378 9.34274 0.949205C8.94651 1.24233 8.65538 1.65541 8.51257 2.12713L5.18915 13.1052C5.14145 13.2628 5.05557 13.4061 4.93915 13.5226L3.3935 15.0682C3.38669 15.075 3.37998 15.0819 3.37337 15.0889L2.60734 15.9006C1.49328 17.081 1.52004 18.9333 2.66774 20.081L3.90641 21.3197C5.06216 22.4755 6.93042 22.4933 8.10807 21.3599L10.0225 19.5174L10.0362 19.504L11.8347 17.7055C12.5814 16.9559 13.0008 15.9407 13.0009 14.8827V2.7869C12.9996 2.17992 12.7576 1.59825 12.3279 1.16952C11.8986 0.741138 11.317 0.500401 10.7105 0.500012ZM10.7105 0.500012C10.71 0.500012 10.7095 0.500011 10.709 0.500011L10.709 1.50001L10.712 0.500016C10.7115 0.500014 10.711 0.500013 10.7105 0.500012Z"
                fill="currentColor"
            />
        </svg>
        <!-- FAX ICON -->
        <svg
            v-if="icon === 'fax'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4 5C4 3.34315 5.34315 2 7 2H12.1716C12.9672 2 13.7303 2.31607 14.2929 2.87868L13.9583 3.21328L14.2929 2.87868L19.1213 7.70711C19.6839 8.26972 20 9.03278 20 9.82843V19C20 20.6569 18.6569 22 17 22H7C5.34315 22 4 20.6569 4 19V5ZM12 4H7C6.44772 4 6 4.44772 6 5V19C6 19.5523 6.44772 20 7 20H17C17.5523 20 18 19.5523 18 19V10H15C13.3431 10 12 8.65685 12 7V4ZM16.5858 8H15C14.4477 8 14 7.55228 14 7V5.41421L16.5858 8ZM8 13C8 12.4477 8.44772 12 9 12H12C12.5523 12 13 12.4477 13 13C13 13.5523 12.5523 14 12 14H9C8.44772 14 8 13.5523 8 13ZM8 17C8 16.4477 8.44772 16 9 16H15.5C16.0523 16 16.5 16.4477 16.5 17C16.5 17.5523 16.0523 18 15.5 18H9C8.44772 18 8 17.5523 8 17Z"
                fill="currentColor"
            />
        </svg>
        <!-- PHONE ICON -->
        <svg
            v-if="icon === 'phone'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.70813 3.20119C6.62966 2.27967 8.17226 2.47155 8.83993 3.59076L10.338 6.10199C10.8073 6.88852 10.6823 7.89325 10.0347 8.54085L9.10045 9.47507C9.72692 10.5746 10.5096 11.6102 11.4492 12.5498C12.3889 13.4895 13.4245 14.2722 14.524 14.8986L15.4582 13.9644C16.1058 13.3168 17.1106 13.1918 17.8971 13.661L20.4083 15.1592C21.5275 15.8268 21.7194 17.3694 20.7979 18.291L18.1972 20.8917C17.4491 21.6397 16.3223 21.9734 15.2541 21.6185C13.9067 21.1709 12.5966 20.5784 11.3482 19.8411C9.90244 18.9873 8.54042 17.9397 7.29993 16.6992C6.05943 15.4587 5.01184 14.0967 4.15794 12.6509C3.42067 11.4025 2.82821 10.0924 2.38055 8.74498C2.02566 7.67675 2.35938 6.54994 3.1074 5.80192L5.70813 3.20119ZM7.12235 4.6154L4.52162 7.21614C4.25998 7.47777 4.18327 7.82762 4.27855 8.11443C4.682 9.32883 5.21583 10.5092 5.88003 11.6338C6.64912 12.936 7.59355 14.1644 8.71414 15.2849C9.83473 16.4055 11.0631 17.35 12.3653 18.1191C13.4899 18.7833 14.6703 19.3171 15.8847 19.7205C16.1715 19.8158 16.5213 19.7391 16.783 19.4775L19.3837 16.8767L16.8724 15.3786L15.4129 16.8381C15.1075 17.1436 14.6404 17.2184 14.2549 17.0236C12.7322 16.2542 11.3049 15.2339 10.035 13.9641C8.76515 12.6942 7.74485 11.2669 6.97551 9.74421C6.78071 9.35866 6.8555 8.8916 7.16095 8.58615L8.62046 7.12664L7.12235 4.6154Z"
                fill="currentColor"
            />
        </svg>
        <!-- PRESS ICON -->
        <svg
            v-if="icon === 'press'"
            :class="svgClass"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 6C2 4.34315 3.34315 3 5 3H14C15.6569 3 17 4.34315 17 6V11H19C20.6569 11 22 12.3431 22 14V17.5C22 19.433 20.433 21 18.5 21H5.5C3.567 21 2 19.433 2 17.5V6ZM15.3368 19H5.5C4.67157 19 4 18.3284 4 17.5V6C4 5.44772 4.44772 5 5 5H14C14.5523 5 15 5.44772 15 6V17.5C15 18.0368 15.1208 18.5454 15.3368 19ZM18.5 19C19.3284 19 20 18.3284 20 17.5V14C20 13.4477 19.5523 13 19 13H17V17.5C17 18.3284 17.6716 19 18.5 19ZM6 8C6 7.44772 6.44772 7 7 7H12C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13H7C6.44772 13 6 12.5523 6 12V8ZM8 9V11H11V9H8ZM6 16C6 15.4477 6.44772 15 7 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H7C6.44772 17 6 16.5523 6 16Z"
                fill="currentColor"
            />
        </svg>
        <!-- ADVANCED SEARCH ICON -->
        <svg
            v-if="icon === 'advanced_search'"
            :class="svgClass"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                id="vector"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.8345 2.49984C15.8345 2.0396 15.4614 1.6665 15.0011 1.6665C14.5409 1.6665 14.1678 2.0396 14.1678 2.49984V4.1676H12.5C12.0398 4.1676 11.6667 4.54069 11.6667 5.00093C11.6667 5.46117 12.0398 5.83426 12.5 5.83426H14.1678V7.49984C14.1678 7.96007 14.5409 8.33317 15.0011 8.33317C15.4614 8.33317 15.8345 7.96007 15.8345 7.49984V5.83426H17.5C17.9603 5.83426 18.3334 5.46117 18.3334 5.00093C18.3334 4.54069 17.9603 4.1676 17.5 4.1676H15.8345V2.49984ZM4.16935 11.0415C4.16935 9.0855 5.75501 7.49984 7.71102 7.49984C9.66703 7.49984 11.2527 9.0855 11.2527 11.0415C11.2527 12.9975 9.66703 14.5832 7.71102 14.5832C5.75501 14.5832 4.16935 12.9975 4.16935 11.0415ZM7.71102 5.83317C4.83454 5.83317 2.50269 8.16502 2.50269 11.0415C2.50269 13.918 4.83454 16.2498 7.71102 16.2498C8.8485 16.2498 9.90081 15.8852 10.7574 15.2664L12.7468 17.2558C13.0722 17.5812 13.5998 17.5812 13.9253 17.2558C14.2507 16.9303 14.2507 16.4027 13.9253 16.0772L11.936 14.0879C12.5547 13.2313 12.9194 12.179 12.9194 11.0415C12.9194 8.16502 10.5875 5.83317 7.71102 5.83317Z"
                fill="currentColor"
                :class="pathClass"
            />
        </svg>
        <!-- ORIGIN ICON -->
        <svg
            v-if="icon === 'origin'"
            :class="svgClass"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.02427 3.3213C5.95467 3.31016 5.91205 3.31602 5.88561 3.32323L5.87254 3.3268L5.43637 3.43065C5.37228 3.44908 5.35106 3.46821 5.34728 3.47171C5.34415 3.4746 5.32892 3.48863 5.31268 3.53835C5.29457 3.59383 5.29812 3.61921 5.29959 3.62756C5.30121 3.63677 5.308 3.66739 5.35004 3.72256L5.35461 3.72856L8.75041 8.27024C8.91628 8.49208 8.96108 8.78182 8.86997 9.04339C8.77885 9.30496 8.56373 9.50416 8.29594 9.57494L5.37927 10.3458C5.11835 10.4147 4.84019 10.3531 4.63286 10.1803L2.63614 8.51635C2.61874 8.51599 2.5991 8.51719 2.57659 8.52075L2.12255 8.63919L2.12388 8.64125L4.02537 11.8174C4.12863 11.9861 4.25783 12.0945 4.42918 12.1644C4.5975 12.2331 4.7613 12.2445 4.9497 12.1938L16.6111 9.04933C16.8467 8.98225 17.0036 8.85872 17.1222 8.65382C17.2375 8.45471 17.2622 8.26676 17.1975 8.03655C17.1306 7.7989 17.0069 7.64096 16.8009 7.5217C16.6018 7.40643 16.4138 7.38173 16.1836 7.44647L16.1757 7.44871L13.055 8.2931C12.5276 8.43579 11.9638 8.31097 11.5459 7.95902L6.05851 3.33698L6.05021 3.32961C6.04842 3.32801 6.04736 3.32732 6.04736 3.32732C6.04736 3.32732 6.03998 3.32381 6.02427 3.3213ZM5.46207 1.71127C5.73635 1.6389 6.01494 1.63194 6.28759 1.67556C6.60545 1.72642 6.89984 1.85829 7.14779 2.07538L12.6196 6.68429L15.7367 5.84084C16.3939 5.65715 17.0447 5.73702 17.636 6.07933C18.2216 6.41841 18.6187 6.93408 18.8019 7.58531C18.9871 8.24399 18.9077 8.89632 18.5646 9.48888C18.2255 10.0746 17.7099 10.4716 17.0586 10.6548L17.05 10.6572L5.3833 13.803C4.84948 13.9467 4.31158 13.9165 3.79935 13.7075C3.2909 13.4999 2.88576 13.1506 2.60035 12.6817L2.59717 12.6765L0.707705 9.52043C0.415264 9.05939 0.36842 8.53216 0.568301 8.02579C0.771687 7.51055 1.17604 7.15934 1.70949 7.0245L2.20847 6.89434L2.23208 6.88961C2.46177 6.84368 2.69665 6.83609 2.93173 6.87321C3.23094 6.92046 3.49142 7.05315 3.70629 7.23863L5.36934 8.6245L6.67604 8.27916L4.02176 4.72927C3.64045 4.22678 3.53022 3.62777 3.72834 3.02101C3.93139 2.39917 4.39397 1.9852 5.0122 1.81875L5.02397 1.81558L5.46207 1.71127Z"
                fill="currentColor"
            />
            <path
                :class="pathClass"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.04144 16.8734C1.04144 16.4132 1.41453 16.0401 1.87477 16.0401H13.1248C13.585 16.0401 13.9581 16.4132 13.9581 16.8734C13.9581 17.3337 13.585 17.7068 13.1248 17.7068H1.87477C1.41453 17.7068 1.04144 17.3337 1.04144 16.8734Z"
                fill="currentColor"
            />
        </svg>
        <!-- DESTINATION ICON -->
        <svg
            v-if="icon === 'destination'"
            :class="svgClass"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.0415 16.8733C6.0415 16.4131 6.4146 16.04 6.87484 16.04H18.1248C18.5851 16.04 18.9582 16.4131 18.9582 16.8733C18.9582 17.3336 18.5851 17.7067 18.1248 17.7067H6.87484C6.4146 17.7067 6.0415 17.3336 6.0415 16.8733Z"
                fill="#1E293B"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.75964 1.88266C8.75455 1.88361 8.72859 1.88859 8.67859 1.92882C8.62985 1.96806 8.62209 1.98983 8.62197 1.99017C8.62114 1.99218 8.61933 1.997 8.61808 2.00727C8.61677 2.01805 8.61571 2.03805 8.61934 2.06954L8.62048 2.07941L9.20376 7.72525C9.23214 8 9.12255 8.27096 8.91115 8.44872C8.69975 8.62648 8.414 8.68794 8.14821 8.61282L5.27321 7.80032C5.01054 7.72609 4.80087 7.52792 4.71196 7.26985L3.85779 4.79069C3.85762 4.79019 3.85745 4.78969 3.85728 4.78919C3.8505 4.78571 3.84237 4.78221 3.83244 4.77881L3.37825 4.66033C3.36208 4.65645 3.35218 4.65554 3.34776 4.65533C3.34489 4.65693 3.34002 4.65992 3.33317 4.66507V8.35257C3.33317 8.54956 3.38707 8.70452 3.49603 8.84753C3.60801 8.9945 3.74936 9.09603 3.94563 9.15788L15.6792 12.4866C15.9984 12.571 16.1757 12.5083 16.3386 12.3569C16.5859 12.1269 16.6665 11.9133 16.6665 11.6859C16.6665 11.4954 16.6133 11.3439 16.5008 11.2008C16.3752 11.0408 16.2291 10.9389 16.0485 10.879L12.8963 9.981C12.3742 9.83224 11.9572 9.43845 11.7788 8.92564L9.42364 2.15449C9.41083 2.12072 9.39164 2.08954 9.3585 2.0564C9.33784 2.03575 9.32802 2.03309 9.32271 2.03166L9.31255 2.02889L8.87507 1.90383C8.86668 1.90144 8.85833 1.89891 8.85002 1.89625C8.79002 1.87705 8.76463 1.88173 8.75964 1.88266ZM9.34397 0.304446C8.73404 0.113922 8.13193 0.22936 7.63358 0.630472C7.12893 1.03665 6.89035 1.61012 6.96303 2.25505L7.41971 6.675L6.14578 6.31497L5.4381 4.26097C5.35223 3.9865 5.19754 3.7406 4.9727 3.54574C4.77488 3.3743 4.54756 3.25311 4.30179 3.17938C4.29214 3.17648 4.28244 3.17376 4.27269 3.17122L3.79352 3.04622L3.78528 3.04411C3.27273 2.91598 2.76319 3.00922 2.33317 3.33173C1.90111 3.65578 1.6665 4.12499 1.6665 4.66507V8.35257C1.6665 8.90557 1.83483 9.41728 2.17031 9.8576C2.50133 10.2921 2.94112 10.5926 3.4631 10.7532L3.48074 10.7584L15.2307 14.0918L15.2422 14.0949C16.0588 14.314 16.8456 14.1613 17.4735 13.5774C18.0179 13.0713 18.3332 12.4308 18.3332 11.6859C18.3332 11.1264 18.1572 10.6113 17.8114 10.171C17.4812 9.75086 17.0543 9.45085 16.5455 9.28805C16.537 9.28532 16.5284 9.28273 16.5198 9.28029L13.353 8.3781L10.9953 1.59963L10.9913 1.58861C10.893 1.31826 10.7388 1.07966 10.537 0.877892C10.3235 0.664409 10.0644 0.507479 9.76637 0.425134L9.34397 0.304446Z"
                fill="#1E293B"
            />
        </svg>
        <!-- START AIRLINE ICON -->
        <svg
            v-if="icon === 'airline'"
            :class="svgClass"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6008 4.42828C10.1355 3.74261 9.36075 3.33203 8.53212 3.33203H5.33669C3.7731 3.33203 2.59321 4.75121 2.87871 6.28851L4.55284 15.303C4.69948 16.0926 5.38837 16.6654 6.19148 16.6654H14.1869C16.1929 16.6654 17.382 14.4216 16.2556 12.7616L10.6008 4.42828ZM8.53212 4.9987C8.80833 4.9987 9.0666 5.13556 9.22169 5.36411L14.8764 13.6974C15.2519 14.2508 14.8556 14.9987 14.1869 14.9987H6.19148L4.51736 5.98419C4.42219 5.47176 4.81549 4.9987 5.33669 4.9987H8.53212Z"
                fill="currentColor"
            />
            <path
                d="M6.49866 9.58203C6.49866 10.7326 7.4314 11.6654 8.582 11.6654C9.73259 11.6654 10.6653 10.7326 10.6653 9.58203C10.6653 8.43144 9.73259 7.4987 8.582 7.4987C7.4314 7.4987 6.49866 8.43144 6.49866 9.58203Z"
                fill="currentColor"
            />
        </svg>
        <!-- START CABIN CLASS ICON -->
        <svg
            v-if="icon === 'cabinClass'"
            :class="svgClass"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.83357 7.50186C8.83357 7.04163 9.20667 6.66853 9.6669 6.66853H13.8336C14.2938 6.66853 14.6669 7.04163 14.6669 7.50186C14.6669 7.9621 14.2938 8.3352 13.8336 8.3352H9.6669C9.20667 8.3352 8.83357 7.9621 8.83357 7.50186Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.13185 3.92917C6.99961 3.48834 6.53504 3.23819 6.09421 3.37044C5.65338 3.50269 5.40323 3.96726 5.53548 4.40808L8.03548 12.7414C8.14122 13.0939 8.46566 13.3353 8.83367 13.3353H14.667C15.1272 13.3353 15.5003 12.9622 15.5003 12.502C15.5003 12.0417 15.1272 11.6686 14.667 11.6686H10.6937C9.95773 11.6686 9.30886 11.1858 9.09737 10.4809L7.13185 3.92917ZM5.6153 1.77406C6.93778 1.37732 8.33149 2.12778 8.72823 3.45026L10.6937 10.002H14.667C16.0477 10.002 17.167 11.1212 17.167 12.502C17.167 13.8827 16.0477 15.002 14.667 15.002H8.83367C7.72965 15.002 6.75634 14.2778 6.4391 13.2203L3.9391 4.887C3.54236 3.56451 4.29281 2.17081 5.6153 1.77406Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.9899 13.5787C11.4308 13.4464 11.8953 13.6966 12.0276 14.1374L12.7869 16.6685H15.9169C16.3771 16.6685 16.7502 17.0416 16.7502 17.5019C16.7502 17.9621 16.3771 18.3352 15.9169 18.3352H9.6669C9.20667 18.3352 8.83357 17.9621 8.83357 17.5019C8.83357 17.0416 9.20667 16.6685 9.6669 16.6685H11.0469L10.4312 14.6163C10.299 14.1755 10.5491 13.7109 10.9899 13.5787Z"
                fill="currentColor"
            />
        </svg>
        <!-- SKY TEAM ALLIANCE LOGO -->

        <svg
            v-if="icon === 'sky_team_alliance_logo'"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 1000 995.9"
            style="enable-background: new 0 0 1000 995.9"
        >
            <title>Asset 1</title>
            <g>
                <path
                    class="st0"
                    d="M790.3,81.1c5.2,2.1,11.2-0.4,13.3-5.6l0.1-0.2c2.1-5.3-0.4-11.3-5.7-13.5c-5.3-2.1-11.3,0.4-13.5,5.7
		S784.9,78.8,790.3,81.1C790.2,81,790.2,81,790.3,81.1L790.3,81.1z M791,79.4c-4.4-1.7-6.5-6.6-4.8-11c0,0,0,0,0,0l0,0
		c1.6-4.3,6.4-6.4,10.7-4.8c0,0,0,0,0,0l0.2,0.1c4.3,1.7,6.5,6.6,4.7,11l0,0C800.2,78.9,795.4,81.1,791,79.4L791,79.4z M796,73.3
		c1.4,0.7,3.1,0.1,3.8-1.3c0,0,0,0,0,0l0.1-0.3c0.5-1.1,0.5-2.4-0.2-3.4c-0.7-0.7-1.6-1.3-2.6-1.6l-5.1-2l-4,10.4l2,0.8l1.6-4.3
		l2.1,0.8l0.6,5.2l2.4,0.9L796,73.3z M792.5,69.9l1-2.9l2.6,1c0.9,0.4,2.4,1,1.9,2.4c-0.5,1.4-1.4,1.4-2.6,0.8L792.5,69.9z"
                />
                <g>
                    <path
                        class="st0"
                        d="M845,216.4l-0.4,0.4c172.5,173.6,171.6,454.1-1.9,626.6c-159.1,158.1-411.3,172.4-587.2,33.2L255,877
			c179,166.8,459.3,156.9,626.1-22.1c166.4-178.6,157-458.2-21.2-625.2C855.1,225.2,850.1,220.7,845,216.4L845,216.4z"
                    />
                    <path
                        class="st0"
                        d="M59.7,720c-14,7.9-17.4,19.7-10,38c6.6,16.5,17.3,23.9,28.5,19.4c9-3.7,10.5-11.4,6.7-31.3l-1.6-7.7
			c-3.4-11.9-4.1-24.4-2-36.6c1.8-8.7,7.9-15.8,16.2-19c20-8,38.9,4.2,50.2,32.4c12.3,30.3,5.7,53.6-18.1,63.4l-6-14.9
			c16.4-7.2,20.6-22.7,12-44.7c-7.3-18.2-18.8-26.1-30.8-21.3c-9.8,3.9-12.2,13-8.5,33.4l1.4,8.6l1.2,7.5c2.3,8.9,2.8,18.1,1.4,27.2
			c-1.8,8.1-7.7,14.6-15.5,17.4c-18.7,7.3-37-3.6-47.2-28.9c-11-27.7-5.2-48,16-57.4L59.7,720z"
                    />
                    <path
                        class="st0"
                        d="M47,560.2l67.3-56.7l0.5,21l-57.2,47.1l18.7,20.3l40-0.9l0.4,16.5L2.3,609.9l-0.5-16.3l45-1h12.1l-4-4
			l-3.7-4.1L0.6,529.8L0,508.1L47,560.2z"
                    />
                    <path
                        class="st0"
                        d="M97.9,383.3l43.9,15.1l-5.4,15.7l-43.9-15.7l-79.1,24l6.5-19L69.1,390l6.1-1.8c2.7-0.8,5.5-1.4,8.3-1.9
			c-3.1-3.6-6-7.3-8.7-11.2l-30.5-41.2l6.3-17.7L97.9,383.3z"
                    />
                    <path
                        class="st0"
                        d="M175.1,173.4L151,202.9l72.2,58.9L206,283.2l-72.1-59l-24.1,29.1l-16.3-13.1l65.6-80.1L175.1,173.4z"
                    />
                    <path
                        class="st0"
                        d="M329.1,65.1l-57.7,33.6l12.4,21.1l52.9-30.9l10.1,16.8l-53.1,31l14.3,24.3l58.9-34.3l10.7,18.3l-82.5,48.1
			l-57.6-98.7l81.1-47.6L329.1,65.1z"
                    />
                    <path
                        class="st0"
                        d="M550.3,109.4l-29.5,1.9l-14.8-24.5l-46.3,7.3l-6.4,28.1l-28.6,7.3l30-124.8l28.3-4.6L550.3,109.4z
			 M485.4,50.5c-4.9-7.4-9.1-15.2-12.5-23.3c-1.1,8.8-2.7,17.6-4.9,26.2l-4.8,21.7l33.6-5.4L485.4,50.5z"
                    />
                    <path
                        class="st0"
                        d="M734.1,146.2l-24-9.4l9.1-33.9c0.9-4,2.4-9.3,4.3-16.2c1.8-6.9,3.6-12.7,5-17c1.4-4.5,2.9-9.3,4.3-14.3
			l2.9-8.1c-6.8,11.5-9.4,15.7-15.7,25.1c-2.6,4.1-5,7.6-7,10.4L680.6,128l-20.9-5.4l-6.5-54.7c-0.5-2.9-0.8-6.7-1.2-12.2
			c-0.3-7.1-0.7-12.6-0.8-16.2c-0.2-3.3-0.2-7.7-0.2-13.9l-2.9,13.7c-3.2,15.1-4.8,21.7-9.3,39.8l-9.6,36.7l-25.6-3.9L632.6,0
			l38.6,7.5l5.4,52.7c1.3,12.5,1.6,25,1,37.5c3.2-6.5,6.8-12.7,10.8-18.8c3.3-5.2,6.1-9.7,8.9-13.7l30-43.2l36.6,12.4L734.1,146.2z"
                    />
                    <path
                        class="st0"
                        d="M515.9,366.2c-13.9,12.1-41.5,38.3-68.1,63.9l-30,28.8c-24.3-4.4-49-6.6-73.7-6.6
			c-55.9,0-106.6,15.3-129.7,39c-8.3,7.5-13,18.2-12.9,29.4c0.5,26.7,31.3,40.4,40.7,44c44.6,19,96,12.3,134.3-17.4
			c26.6-20.1,51.9-42,75.5-65.6c17.6,3.9,37.6,9.3,59.2,15.6l19.9,5.7c-25.7,25.2-52.3,51.6-76.8,73.3l-1.8,1.6
			c-34,30-58.4,51.6-93.8,59.4c-16.1,4.6-33.3,3.4-48.6-3.2c-0.7,0.1-1.4,1.1-1.4,1.1c19.9,18.2,46.8,26.8,73.6,23.5
			c31.9-2.7,68.7-22.6,106.6-57.7l50.5-50l35.2-35.3c0,0.1,72,21.1,72,21.1c0.5,0.1,1,0.2,1.4,0.4c-0.9,0-44.9,43.3-44.9,43.3
			L565,618.5c-25.6,26.8-53.4,51.5-83,73.9c-38.2,26.9-70.3,41-98.9,42.7c-18.7,1.8-37.4-1.9-54.1-10.5c-0.8-0.1-1.7,0.9-1.7,0.9
			c22,22.6,52.3,35.3,83.9,35.1c46.2-1.2,87.1-23.4,150.2-81.8c29-26.9,58-56.3,83.5-82.7l47.2-47.9c29.5,6.8,59.7,9.8,89.9,9.1
			c44.8-0.8,82.5-22.3,83-46.8c-1.1-14.5-9.9-27.4-23-33.6c-16.5-10.3-35.5-15.8-55-15.7c-38.8,2-75.6,17.6-104.1,44l-23.8,20.9
			c0.3-0.2-8.7-2.4-8.7-2.4l-65.8-18.3c19.4-18.2,35.9-33.9,50.9-46.9c27.3-25.5,61.9-41.9,99-46.7c16.9-1.1,46.8,0.4,58.9,9.1
			c0.5-0.2,1.3-1.4,1.3-1.4c-22.7-21-52.8-32.2-83.7-31.2c-22.8,0-59.2,7.2-104.1,41.8c-23.4,19.6-45.5,40.5-66.3,62.8
			c0-0.3-33.2-10.3-33.2-10.3l-8.1-2.5l-35.1-10.6c0.8,0,20.2-18.8,20.2-18.8c23.4-23,45.8-45,62.9-59.5
			c62.7-53,102.8-60,130.3-60.3c25.1-1.4,50.1,5.1,71.3,18.6c0.5,0,1.4-1.1,1.4-1.1c-27.2-28.7-65.4-44.2-104.9-42.6
			C606.6,305.1,560.6,326.6,515.9,366.2z M267.5,555.2c-20-1.4-30-9.7-30-25.4c0-2.1,1.4-52.2,115.7-57.9c16.7-1,33.4-0.5,50,1.4
			c-1,0.2-13,11.2-13,11.2l-7,6.6C355.4,516.2,308.9,557.8,267.5,555.2z M731.4,514.6c33.2-22.2,60.5-34.1,77.5-33.5
			c10.1,0.4,22.2,3.5,22.2,16c0,12.5-12.2,23.5-36,32c-28.8,8-58.9,9.8-88.4,5.3C714.6,527.4,722.8,520.7,731.4,514.6L731.4,514.6z"
                    />
                </g>
            </g>
        </svg>

        <!-- ONE WORLD ALLIANCE LOGO -->
        <svg
            v-if="icon === 'one_world_alliance_logo'"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="20px"
            height="20px"
            viewBox="0 0 10 10"
            version="1.1"
            style="enable-background: new 0 0 1000 995.9; transform: scale(1.5)"
        >
            <defs>
                <radialGradient
                    id="radial0"
                    gradientUnits="userSpaceOnUse"
                    cx="250"
                    cy="250"
                    fx="250"
                    fy="250"
                    r="250"
                    gradientTransform="matrix(0.0200803,0,0,0.0200803,-0.0200803,-0.0200803)"
                >
                    <stop
                        offset="0"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0;
                        "
                    />
                    <stop
                        offset="0.5"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0.2;
                        "
                    />
                    <stop
                        offset="0.8"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0.74902;
                        "
                    />
                    <stop
                        offset="1"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 1;
                        "
                    />
                </radialGradient>
                <radialGradient
                    id="radial1"
                    gradientUnits="userSpaceOnUse"
                    cx="250"
                    cy="250"
                    fx="108"
                    fy="60"
                    r="300"
                    gradientTransform="matrix(0.0200803,0,0,0.0200803,-0.0200803,-0.0200803)"
                >
                    <stop
                        offset="0"
                        style="
                            stop-color: rgb(100%, 100%, 100%);
                            stop-opacity: 0.94902;
                        "
                    />
                    <stop
                        offset="0.25"
                        style="
                            stop-color: rgb(100%, 100%, 100%);
                            stop-opacity: 0.85098;
                        "
                    />
                    <stop
                        offset="0.85"
                        style="
                            stop-color: rgb(100%, 100%, 100%);
                            stop-opacity: 0;
                        "
                    />
                    <stop
                        offset="1"
                        style="
                            stop-color: rgb(100%, 100%, 100%);
                            stop-opacity: 0;
                        "
                    />
                </radialGradient>
                <radialGradient
                    id="radial2"
                    gradientUnits="userSpaceOnUse"
                    cx="250"
                    cy="250"
                    fx="250"
                    fy="250"
                    r="249"
                    gradientTransform="matrix(0.0200803,0,0,0.0200803,-0.0200803,-0.0200803)"
                >
                    <stop
                        offset="0"
                        style="
                            stop-color: rgb(32.54902%, 30.980392%, 63.921569%);
                            stop-opacity: 1;
                        "
                    />
                    <stop
                        offset="0.47"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0.54902;
                        "
                    />
                    <stop
                        offset="1"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0;
                        "
                    />
                </radialGradient>
                <radialGradient
                    id="radial3"
                    gradientUnits="userSpaceOnUse"
                    cx="250"
                    cy="250"
                    fx="108"
                    fy="60"
                    r="249"
                    gradientTransform="matrix(0.0200803,0,0,0.0200803,-0.0200803,-0.0200803)"
                >
                    <stop
                        offset="0"
                        style="
                            stop-color: rgb(100%, 100%, 100%);
                            stop-opacity: 0.698039;
                        "
                    />
                    <stop
                        offset="0.25"
                        style="
                            stop-color: rgb(100%, 100%, 100%);
                            stop-opacity: 0.34902;
                        "
                    />
                    <stop
                        offset="1"
                        style="
                            stop-color: rgb(58.431373%, 57.254902%, 78.039216%);
                            stop-opacity: 0;
                        "
                    />
                </radialGradient>
                <radialGradient
                    id="radial4"
                    gradientUnits="userSpaceOnUse"
                    cx="250"
                    cy="250"
                    fx="250"
                    fy="250"
                    r="249"
                    gradientTransform="matrix(0.0200803,0,0,0.0200803,-0.0200803,-0.0200803)"
                >
                    <stop
                        offset="0"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0;
                        "
                    />
                    <stop
                        offset="0.89"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0;
                        "
                    />
                    <stop
                        offset="0.97"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0.0705882;
                        "
                    />
                    <stop
                        offset="1"
                        style="
                            stop-color: rgb(9.803922%, 9.803922%, 52.941176%);
                            stop-opacity: 0.2;
                        "
                    />
                </radialGradient>
            </defs>
            <g id="surface1">
                <path
                    style="
                        stroke: none;
                        fill-rule: nonzero;
                        fill: rgb(34.117648%, 32.156864%, 65.098041%);
                        fill-opacity: 1;
                    "
                    d="M 10 5 C 10 2.238281 7.761719 0 5 0 C 2.238281 0 0 2.238281 0 5 C 0 7.761719 2.238281 10 5 10 C 7.761719 10 10 7.761719 10 5 Z M 10 5 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: nonzero;
                        fill: url(#radial0);
                    "
                    d="M 10 5 C 10 2.238281 7.761719 0 5 0 C 2.238281 0 0 2.238281 0 5 C 0 7.761719 2.238281 10 5 10 C 7.761719 10 10 7.761719 10 5 Z M 10 5 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: nonzero;
                        fill: url(#radial1);
                    "
                    d="M 10 5 C 10 2.238281 7.761719 0 5 0 C 2.238281 0 0 2.238281 0 5 C 0 7.761719 2.238281 10 5 10 C 7.761719 10 10 7.761719 10 5 Z M 10 5 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: nonzero;
                        fill: url(#radial2);
                    "
                    d="M 10 5 C 10 2.238281 7.761719 0 5 0 C 2.238281 0 0 2.238281 0 5 C 0 7.761719 2.238281 10 5 10 C 7.761719 10 10 7.761719 10 5 Z M 10 5 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: nonzero;
                        fill: url(#radial3);
                    "
                    d="M 10 5 C 10 2.238281 7.761719 0 5 0 C 2.238281 0 0 2.238281 0 5 C 0 7.761719 2.238281 10 5 10 C 7.761719 10 10 7.761719 10 5 Z M 10 5 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: nonzero;
                        fill: url(#radial4);
                    "
                    d="M 10 5 C 10 2.238281 7.761719 0 5 0 C 2.238281 0 0 2.238281 0 5 C 0 7.761719 2.238281 10 5 10 C 7.761719 10 10 7.761719 10 5 Z M 10 5 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: evenodd;
                        fill: rgb(100%, 100%, 100%);
                        fill-opacity: 1;
                    "
                    d="M 1.050781 5.714844 C 1.394531 5.714844 1.660156 5.523438 1.660156 5.113281 C 1.660156 4.710938 1.398438 4.519531 1.050781 4.519531 C 0.742188 4.519531 0.445312 4.675781 0.445312 5.113281 C 0.445312 5.523438 0.707031 5.714844 1.050781 5.714844 M 1.050781 5.453125 C 0.839844 5.453125 0.816406 5.242188 0.816406 5.113281 C 0.816406 4.796875 0.984375 4.78125 1.050781 4.78125 C 1.125 4.78125 1.285156 4.796875 1.285156 5.113281 C 1.285156 5.242188 1.265625 5.453125 1.050781 5.453125 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: evenodd;
                        fill: rgb(100%, 100%, 100%);
                        fill-opacity: 1;
                    "
                    d="M 2.175781 4.5625 L 1.84375 4.5625 L 1.84375 5.671875 L 2.191406 5.671875 L 2.191406 5.097656 C 2.191406 5.050781 2.195312 4.792969 2.421875 4.792969 C 2.609375 4.792969 2.621094 4.972656 2.621094 5.082031 L 2.621094 5.671875 L 2.964844 5.671875 L 2.964844 4.972656 C 2.964844 4.5625 2.734375 4.519531 2.578125 4.519531 C 2.421875 4.519531 2.269531 4.574219 2.175781 4.695312 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: evenodd;
                        fill: rgb(100%, 100%, 100%);
                        fill-opacity: 1;
                    "
                    d="M 3.96875 5.351562 C 3.9375 5.449219 3.863281 5.464844 3.769531 5.464844 C 3.558594 5.464844 3.519531 5.304688 3.519531 5.199219 L 4.351562 5.199219 L 4.351562 5.136719 C 4.347656 5 4.316406 4.519531 3.777344 4.519531 C 3.414062 4.519531 3.15625 4.730469 3.15625 5.113281 C 3.15625 5.679688 3.605469 5.714844 3.753906 5.714844 C 3.957031 5.714844 4.242188 5.664062 4.328125 5.351562 M 3.519531 5.011719 C 3.523438 4.898438 3.578125 4.75 3.773438 4.75 C 3.855469 4.75 3.976562 4.773438 3.984375 5.011719 Z M 3.519531 5.011719 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: evenodd;
                        fill: rgb(100%, 100%, 100%);
                        fill-opacity: 1;
                    "
                    d="M 5.203125 4.675781 L 5.5 5.671875 L 5.632812 5.671875 L 5.972656 4.5625 L 5.867188 4.5625 L 5.5625 5.554688 L 5.265625 4.5625 L 5.144531 4.5625 L 4.847656 5.554688 L 4.542969 4.5625 L 4.4375 4.5625 L 4.777344 5.671875 L 4.910156 5.671875 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: evenodd;
                        fill: rgb(100%, 100%, 100%);
                        fill-opacity: 1;
                    "
                    d="M 6.089844 5.117188 C 6.089844 5.445312 6.238281 5.714844 6.609375 5.714844 C 6.980469 5.714844 7.128906 5.445312 7.128906 5.117188 C 7.128906 4.785156 6.980469 4.519531 6.609375 4.519531 C 6.238281 4.519531 6.089844 4.785156 6.089844 5.117188 M 6.191406 5.117188 C 6.191406 4.800781 6.328125 4.59375 6.609375 4.59375 C 6.890625 4.59375 7.027344 4.800781 7.027344 5.117188 C 7.027344 5.429688 6.890625 5.640625 6.609375 5.640625 C 6.328125 5.640625 6.191406 5.429688 6.191406 5.117188 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: evenodd;
                        fill: rgb(100%, 100%, 100%);
                        fill-opacity: 1;
                    "
                    d="M 7.898438 4.539062 L 7.847656 4.539062 C 7.660156 4.539062 7.519531 4.652344 7.464844 4.792969 L 7.460938 4.792969 L 7.460938 4.5625 L 7.363281 4.5625 L 7.363281 5.671875 L 7.460938 5.671875 L 7.460938 5.140625 C 7.460938 4.691406 7.703125 4.644531 7.847656 4.636719 L 7.898438 4.636719 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: nonzero;
                        fill: rgb(100%, 100%, 100%);
                        fill-opacity: 1;
                    "
                    d="M 8.082031 4.140625 L 8.175781 4.140625 L 8.175781 5.671875 L 8.082031 5.671875 Z M 8.082031 4.140625 "
                />
                <path
                    style="
                        stroke: none;
                        fill-rule: evenodd;
                        fill: rgb(100%, 100%, 100%);
                        fill-opacity: 1;
                    "
                    d="M 9.300781 4.140625 L 9.300781 4.746094 C 9.226562 4.597656 9.074219 4.519531 8.898438 4.519531 C 8.636719 4.519531 8.410156 4.6875 8.410156 5.101562 C 8.410156 5.222656 8.429688 5.714844 8.90625 5.714844 C 9.191406 5.714844 9.277344 5.539062 9.296875 5.496094 L 9.300781 5.496094 L 9.300781 5.671875 L 9.398438 5.671875 L 9.398438 4.140625 M 8.515625 5.097656 C 8.515625 4.863281 8.609375 4.59375 8.894531 4.59375 C 9.152344 4.59375 9.304688 4.800781 9.304688 5.125 C 9.304688 5.5 9.097656 5.640625 8.898438 5.640625 C 8.8125 5.640625 8.515625 5.617188 8.515625 5.097656 "
                />
            </g>
        </svg>

        <!-- STAR ALLIANCE LOGO -->
        <svg
            v-if="icon === 'star_alliance_logo'"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="60px"
            height="60px"
            viewBox="0 0 200 115"
            enable-background="new 0 0 200 115"
            style="enable-background: new 0 0 1000 995.9; transform: scale(1.5)"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#C9CBCD"
                d="M78.568,24.125c2.972-4.122,6.272-8.088,9.905-11.851
			c3.646-3.775,7.501-7.227,11.532-10.349l-4.313,17.288L78.568,24.125L78.568,24.125z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#5B5C5E"
                d="M108.51,31.59c-5.056-0.513-10.141-1.388-15.216-2.653
			c-5.092-1.27-10.009-2.883-14.729-4.813l17.128-4.91L108.51,31.59L108.51,31.59z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#999B9D"
                d="M100.004,1.929c2.084,4.635,3.869,9.475,5.311,14.503
			c1.447,5.045,2.508,10.109,3.196,15.161L95.693,19.214L100.004,1.929L100.004,1.929z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#999B9D"
                d="M72.519,59.657c-3.003-4.099-5.754-8.463-8.209-13.081
			c-2.465-4.634-4.556-9.367-6.279-14.166l15.109,9.444L72.519,59.657L72.519,59.657z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#5B5C5E"
                d="M88.87,33.49c-2.05,4.649-4.454,9.215-7.225,13.65
			c-2.781,4.451-5.835,8.629-9.129,12.52l0.623-17.806L88.87,33.49L88.87,33.49z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#C9CBCD"
                d="M58.032,32.413c5.052-0.55,10.207-0.751,15.434-0.568
			c5.245,0.184,10.391,0.739,15.408,1.646L73.14,41.854L58.032,32.413L58.032,32.413z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#5B5C5E"
                d="M104.444,76.394c-4.828,1.588-9.829,2.855-14.98,3.764
			c-5.168,0.91-10.316,1.438-15.412,1.593l13.65-11.451L104.444,76.394L104.444,76.394z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#999B9D"
                d="M84.609,52.755c3.788,3.387,7.387,7.084,10.748,11.089
			c3.375,4.022,6.404,8.216,9.088,12.552l-16.743-6.097L84.609,52.755L84.609,52.755z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#C9CBCD"
                d="M74.054,81.75c1.039-4.975,2.441-9.939,4.229-14.854
			c1.796-4.933,3.914-9.653,6.327-14.145l3.092,17.547L74.054,81.75L74.054,81.75z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#999B9D"
                d="M130.225,51.203c0.019,5.081-0.32,10.229-1.049,15.407
			c-0.729,5.197-1.821,10.257-3.246,15.151l-6.674-16.521L130.225,51.203L130.225,51.203z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#C9CBCD"
                d="M101.613,62.76c4.393-2.556,9.021-4.836,13.869-6.795
			c4.867-1.966,9.792-3.551,14.744-4.764L119.256,65.24L101.613,62.76L101.613,62.76z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#5B5C5E"
                d="M125.93,81.76c-4.411-2.524-8.699-5.393-12.82-8.614
			c-4.137-3.231-7.971-6.704-11.498-10.386l17.645,2.48L125.93,81.76L125.93,81.76z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#999B9D"
                d="M114.234,18.899c4.838,1.552,9.629,3.466,14.33,5.759
			c4.718,2.301,9.191,4.901,13.406,7.77l-17.774,1.241L114.234,18.899L114.234,18.899z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#C9CBCD"
                d="M116.386,49.681c-1.076-4.967-1.813-10.073-2.179-15.29
			c-0.366-5.235-0.35-10.409,0.027-15.494l9.962,14.772L116.386,49.681L116.386,49.681z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                fill="#5B5C5E"
                d="M141.968,32.428c-3.764,3.413-7.817,6.605-12.152,9.53
			c-4.352,2.935-8.841,5.509-13.433,7.725l7.813-16.014L141.968,32.428L141.968,32.428z"
            />

            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.07,104.348c-2.853-0.289-5.548-0.561-5.548-3.255
			c0-1.234,0.649-2.158,1.934-2.75c1.257-0.577,2.758-0.664,3.541-0.664c1.087,0,3.082,0.174,4.238,1.328
			c0.563,0.565,0.85,1.293,0.85,2.166c0,0.141-0.003,0.263-0.021,0.385h0.924c0.003-0.068,0.006-0.136,0.012-0.202
			c0.007-0.077,0.013-0.157,0.013-0.234c0-1.096-0.346-1.997-1.027-2.68c-1.287-1.286-3.495-1.556-5.12-1.556
			c-1.635,0-4.016,0.472-5.348,1.805c-0.665,0.666-1.003,1.474-1.003,2.402c0,3.511,3.158,3.795,6.212,4.069
			c1.479,0.134,2.878,0.26,3.946,0.728c1.204,0.525,1.789,1.434,1.789,2.775c0,0.859-0.288,1.582-0.857,2.152
			c-1.283,1.283-3.611,1.422-4.554,1.422c-2.311,0-3.996-0.514-5.009-1.525c-0.749-0.751-1.132-1.783-1.14-3.071H0
			c-0.001,1.509,0.439,2.719,1.313,3.6c1.182,1.187,3.147,1.79,5.844,1.79c1.483,0,6.323-0.319,6.323-4.442
			C13.479,104.995,10.222,104.667,7.07,104.348L7.07,104.348z"
            />
            <polygon
                fill-rule="evenodd"
                clip-rule="evenodd"
                points="23.303,98.065 23.303,112.729 22.344,112.729 22.344,98.065
			16.05,98.065 16.05,97.188 29.597,97.188 29.597,98.065 23.303,98.065 		"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M44.18,112.729l-2.284-5.021h-8.644l-2.311,5.021h-1.053l7.146-15.541h1.089
			l7.146,15.541H44.18L44.18,112.729z M37.565,98.226l-3.932,8.633h7.89L37.565,98.226L37.565,98.226z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M62.029,112.729c-0.266-0.268-0.371-1.248-0.425-3.613
			c-0.08-2.711-0.93-3.454-4.012-3.454h-6.721v7.067h-0.979V97.188h7.727c2.976,0,5.26,0.85,5.26,4.118
			c0,1.619-0.982,3.346-3.188,3.851v0.054c1.887,0.239,2.896,1.542,2.923,3.215c0.026,2.816,0.132,3.745,0.425,4.304H62.029
			L62.029,112.729z M57.699,98.065h-6.827v6.721h6.588c0.957,0,4.409,0,4.409-3.533C61.869,98.73,59.904,98.065,57.699,98.065
			L57.699,98.065z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M88.086,112.729l-2.311-5.021h-8.644l-2.285,5.021h-1.078l7.145-15.541h1.116
			l7.119,15.541H88.086L88.086,112.729z M81.472,98.226l-3.958,8.633h7.89L81.472,98.226L81.472,98.226z"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M142.887,112.729l-2.312-5.021h-8.644l-2.284,5.021h-1.078l7.145-15.541h1.116
			l7.118,15.541H142.887L142.887,112.729z M136.271,98.226l-3.957,8.633h7.889L136.271,98.226L136.271,98.226z"
            />
            <polygon
                fill-rule="evenodd"
                clip-rule="evenodd"
                points="104.874,111.852 94.999,111.852 94.999,97.188 94.019,97.188
			94.019,112.729 104.874,112.729 104.874,111.852 		"
            />
            <polygon
                fill-rule="evenodd"
                clip-rule="evenodd"
                points="119.233,111.852 109.378,111.852 109.378,97.188 108.397,97.188
			108.397,112.729 119.233,112.729 119.233,111.852 		"
            />
            <polygon
                fill-rule="evenodd"
                clip-rule="evenodd"
                points="122.689,112.729 122.689,97.188 123.649,97.188 123.649,112.729
			122.689,112.729 		"
            />
            <polygon
                fill-rule="evenodd"
                clip-rule="evenodd"
                points="161.003,112.729 149.342,98.597 149.288,98.597 149.288,112.729
			148.335,112.729 148.335,97.188 149.502,97.188 161.163,111.321 161.216,111.373 161.216,97.188 162.169,97.188 162.169,112.729
			161.003,112.729 		"
            />
            <polygon
                fill-rule="evenodd"
                clip-rule="evenodd"
                points="187.74,112.729 187.74,97.188 199.867,97.188 199.867,98.065
			188.711,98.065 188.711,104.254 199.416,104.254 199.416,105.105 188.711,105.105 188.711,111.852 200,111.852 200,112.729
			187.74,112.729 		"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M175.03,113.074c-4.728,0-8.011-2.966-8.011-8.093
			c0-4.063,2.662-8.138,8.073-8.138c3.718,0,6.525,1.753,7.297,5.232h-0.984c-0.743-3.001-3.418-4.355-6.313-4.355
			c-4.463,0-7.063,3.32-7.063,7.251c0,3.879,2.221,7.226,7.001,7.226c3.427,0,6.03-1.993,6.614-5.364h1.01
			C182.31,109.78,179.679,113.074,175.03,113.074L175.03,113.074z"
            />
        </svg>
    </div>
</template>

<script setup>
defineProps({
    icon: {
        type: String,
        required: true,
    },
    svgClass: {
        type: String,
        default: 'fill-none',
    },
    pathClass: {
        type: String,
        default: 'fill-slate-800',
    },
    width: {
        type: Number,
        default: 20,
    },
    height: {
        type: Number,
        default: 20,
    },
    size: {
        type: String,
        default: 'medium',
    },
});
</script>
